(function () {
  var FLAG = "ap_cart_drawer";
  var PRIORITY_PLUS_STATE_KEY = "ap_priority_plus_selected_v2";
  var BUNDLE_CACHE_KEY = "ap_cart_bundle_groups_v3";
  var CART_GROUP_CACHE_KEY = "ap_cart_merch_groups_v1";
  var ROOM_MIST_UPSELL_HANDLE = "ritz-carlton-hotel-inspired-room-mist-spray";
  var HUMIDIFYING_CLEANER_UPSELL_HANDLE = "humidifying-diffuser-cleaner-descaling-residue-removal-solution-for-ultrasonic-diffusers";
  var WATERLESS_CLEANER_UPSELL_HANDLE = "waterless-diffuser-cleaning-liquid-residue-free-formula-for-cold-air-nebulizing-diffusers";
  var CHECKOUT_RETURN_PATH_KEY = "ap_checkout_return_path";
  var DROPPER_UPSELL_HANDLE = "fragrance-dropper";
  var DROPPER_ELIGIBLE_CACHE_KEY = "ap_cart_dropper_eligible_v1";
  var root = document.querySelector("[data-ap-cart]");
  if (!root) return;
  var i18n = {};
  try {
    var i18nNode = root.querySelector("[data-ap-cart-i18n]");
    i18n = i18nNode ? JSON.parse(i18nNode.textContent) : {};
  } catch (e) {}
  var localeRoot = String(i18n.root || "/").replace(/\/$/, "");

  function text(key, fallback) {
    return i18n[key] || fallback || "";
  }

  function formatText(key, fallback, values) {
    var value = text(key, fallback);
    Object.keys(values || {}).forEach(function (token) {
      value = value.split("__" + token.toUpperCase() + "__").join(String(values[token]));
    });
    return value;
  }

  function localePath(path) {
    path = String(path || "");
    if (!path || path === "#" || /^(?:https?:)?\/\//i.test(path)) return path;
    if (localeRoot && (path === localeRoot || path.indexOf(localeRoot + "/") === 0)) return path;
    return localeRoot + "/" + path.replace(/^\//, "");
  }

  var state = {
    cart: null,
    cartFetch: null,
    refreshTimer: null,
    recsTimer: null,
    mutationTimer: null,
    recommendationsFor: null,
    recommendationsAbort: null,
    groupRecommendations: {},
    groupRecommendationAborts: {},
    bundleSuggestions: {},
    bundleSuggestionHtml: {},
    bundleSuggestionAborts: {},
    bundleGroupsLoaded: false,
    bundleGroupsLoading: null,
    bundleProductGroups: {},
    cartGroupsLoaded: false,
    cartGroupsLoading: null,
    cartProductGroups: {},
    errorTimer: null,
    removalTimer: null,
    removedLine: null,
    loyaltyTimer: null,
    priorityPlusEnabled: readPriorityPlusPreference(),
    priorityPlusCleanupKey: null,
    protectionCleanupKey: null,
    recommendationsPrimedFor: null,
    roomMistUpsellProduct: null,
    roomMistUpsellLoading: null,
    roomMistUpsellUnavailable: false,
    humidifyingCleanerProduct: null,
    humidifyingCleanerLoading: null,
    humidifyingCleanerUnavailable: false,
    waterlessCleanerProduct: null,
    waterlessCleanerLoading: null,
    waterlessCleanerUnavailable: false,
    dropperProduct: null,
    dropperLoading: null,
    dropperUnavailable: false,
    dropperEligibleLoaded: false,
    dropperEligibleLoading: null,
    dropperEligibleProducts: {},
    sizeUpgradeProducts: {},
    sizeUpgradeLoading: {},
    sizeUpgradeExpanded: false,
    sizeUpgradeBusy: false,
    sizeUpgradeUndo: null,
    sizeUpgradeSuccess: null,
    returnFocus: null,
    afterAdd: null
  };

  var BUNDLE_GROUPS = [
    { key: "regular-hotel", label: text("hotel_oils", "Hotel fragrance oils"), handle: "hotel-collection-fragrance-oils" },
    { key: "regular-perfume", label: text("perfume_oils", "Perfume fragrance oils"), handle: "perfume-fragrance-oils" },
    { key: "regular-nature", label: text("nature_oils", "Nature fragrance oils"), handle: "nature-inspired-fragrance-oils" },
    { key: "waterless-oils", label: text("waterless_oils", "Waterless fragrance oils"), handle: "waterless-fragrance-oils-1" },
    { key: "incense-sticks", label: text("incense_sticks", "Handcrafted incense sticks"), handle: "incense-sticks" },
    { key: "perfume-body-oils", label: text("body_oils", "Perfume body oils"), handle: "perfume-body-oils" },
    { key: "bracelets", label: text("bracelets", "Bracelets"), handle: "bracelets" }
  ];

  var FRAGRANCE_OIL_OFFER_GROUPS = ["regular-hotel", "regular-perfume", "regular-nature", "waterless-oils"];

  var CART_GROUPS = [
    { key: "humidifying-diffusers", label: text("humidifying_diffusers", "Humidifying diffusers"), handle: "humidifying-scent-diffusers", recommendations: true },
    { key: "waterless-diffusers", label: text("waterless_diffusers", "Waterless diffusers"), handle: "waterless-scent-diffusers", recommendations: true },
    { key: "sand-candles", label: text("sand_candles", "Sand candles"), handle: "sand-candle" },
    { key: "magic-spell-candles", label: text("magic_spell_candles", "Magic spell candles"), handle: "magic-spell-candles" },
    { key: "incense-holders", label: text("incense_holders", "Incense holders"), handle: "incense-holders" }
  ];

  var DROPPER_ELIGIBLE_COLLECTIONS = [
    { key: "regular-fragrance-oils", handle: "regular-fragrance-oils" },
    { key: "essential-oils", handle: "essential-oils" }
  ];

  function hasFlag() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("ap_cart") === "1") {
        window.localStorage.setItem(FLAG, "1");
        return true;
      }
      if (params.get("ap_cart") === "0") {
        window.localStorage.setItem(FLAG, "0");
        return false;
      }
      return window.localStorage.getItem(FLAG) !== "0";
    } catch (e) {
      return true;
    }
  }

  function shouldOpenOnLoad() {
    try {
      return new URLSearchParams(window.location.search).get("ap_cart_open") === "1";
    } catch (e) {
      return false;
    }
  }

  function rememberCheckoutReturnPath() {
    try {
      window.sessionStorage.setItem(CHECKOUT_RETURN_PATH_KEY, window.location.pathname + window.location.search + window.location.hash);
    } catch (e) {}
  }

  function money(cents) {
    cents = Number(cents || 0);
    var amount = cents / 100;
    return "$" + (Number.isInteger(amount) ? String(amount) : amount.toFixed(2));
  }

  function readPriorityPlusPreference() {
    try {
      var preference = window.sessionStorage.getItem(PRIORITY_PLUS_STATE_KEY);
      return preference === null ? true : preference === "1";
    } catch (e) {
      return true;
    }
  }

  function writePriorityPlusPreference(enabled) {
    state.priorityPlusEnabled = Boolean(enabled);
    try {
      window.sessionStorage.setItem(PRIORITY_PLUS_STATE_KEY, enabled ? "1" : "0");
    } catch (e) {}
  }

  function normalizePrice(value) {
    if (typeof value === "string") {
      value = value.replace(/[^0-9.]/g, "");
      if (value.indexOf(".") !== -1) return Math.round(Number(value) * 100);
    }
    return Number(value || 0);
  }

  function productPrice(product, variant) {
    var price = (variant && variant.price != null) ? variant.price : product && product.price;
    price = normalizePrice(price);
    if (!price) return "";
    return money(price);
  }

  function api(path, options) {
    options = options || {};
    options.credentials = "same-origin";
    options.headers = Object.assign({
      "Accept": "application/json"
    }, options.headers || {});
    options.apCartOwned = true;
    return fetch(path, options).then(function (res) {
      if (!res.ok) throw new Error("Cart request failed: " + res.status);
      return res.json();
    });
  }

  function hiddenCartUrl(url) {
    if (!/\/cart\/add(\.js)?(\?|$)/.test(String(url || ""))) return url;
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set("hide_upez_cart", "true");
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      return String(url).indexOf("?") === -1
        ? String(url) + "?hide_upez_cart=true"
        : String(url) + "&hide_upez_cart=true";
    }
  }

  function isCollectionPage() {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections(\/|$)/i.test(window.location.pathname);
  }

  function isProductPage() {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(window.location.pathname);
  }

  function shouldOpenAfterAdd() {
    return !isCollectionPage();
  }

  function openOrRefreshAfterAdd() {
    if (state.afterAdd) return state.afterAdd;
    state.afterAdd = fetchCart().then(function () {
      if (shouldOpenAfterAdd()) openCart({ skipRefresh: true });
      else bridgeLoyaltyWidget();
      scheduleCartRefresh(700);
    }).finally(function () { state.afterAdd = null; });
    return state.afterAdd;
  }

  function showError(message) {
    var error = root.querySelector("[data-ap-cart-error]");
    if (!error) return;
    window.clearTimeout(state.errorTimer);
    error.textContent = message || text("update_error", "We couldn't update your cart. Please try again.");
    error.hidden = false;
    state.errorTimer = window.setTimeout(function () {
      error.hidden = true;
    }, 5200);
  }

  function clearError() {
    var error = root.querySelector("[data-ap-cart-error]");
    if (error) error.hidden = true;
    window.clearTimeout(state.errorTimer);
  }

  function showRemovalNotice(item, index) {
    window.clearTimeout(state.removalTimer);
    state.removedLine = item;
    state.removalIndex = index;
    state.removalRestoring = false;
    state.removalTimer = window.setTimeout(function () {
      state.removedLine = null;
      if (state.cart) renderItems(state.cart);
    }, 3000);
  }

  function undoRemoval() {
    var item = state.removedLine;
    if (!item || state.removalRestoring) return;
    state.removalRestoring = true;
    window.clearTimeout(state.removalTimer);
    renderItems(state.cart);
    var restored = { id: item.variant_id, quantity: item.quantity, properties: item.properties || {} };
    if (item.selling_plan_allocation) restored.selling_plan = item.selling_plan_allocation.selling_plan.id;
    addCartItems([restored].concat((item.__tbMinis || []).map(function (m) { return { id: m.variant_id, quantity: m.quantity, properties: m.properties || {} }; }))).then(function () {
      return api(localePath("/cart.js") + "?ap_cart=1&t=" + Date.now());
    }).then(function (cart) {
      if (state.removedLine === item) state.removedLine = null;
      state.cart = cart;
      clearError();
      render(cart);
      document.dispatchEvent(new CustomEvent("ap-cart:updated", { bubbles: true, detail: cart }));
    }).catch(function () {
      showError(text("undo_remove_error", "We couldn't restore this item. Please add it again."));
    }).finally(function () {
      if (state.removedLine === item) {
        state.removedLine = null;
        if (state.cart) renderItems(state.cart);
      }
    });
  }

  function setLineBusy(key, busy) {
    root.querySelectorAll("[data-ap-cart-qty]").forEach(function (button) {
      if (button.getAttribute("data-ap-cart-qty") !== key) return;
      button.disabled = busy;
      button.classList.toggle("is-busy", busy);
    });
  }

  function installScrollStyles() {
    if (document.getElementById("ap-cart-scroll-fix")) return;
    var style = document.createElement("style");
    style.id = "ap-cart-scroll-fix";
    style.textContent = [
      ".ap-cart__panel{display:flex!important;flex-direction:column!important;overflow:hidden!important;}",
      ".ap-cart__header,.ap-cart__footer{flex:0 0 auto!important;}",
      ".ap-cart__body{flex:1 1 auto!important;min-height:0!important;overflow-x:hidden!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;touch-action:auto!important;overscroll-behavior:contain!important;}",
      ".ap-cart__items{overflow:visible!important;}"
    ].join("");
    document.head.appendChild(style);
  }

  function installScrollGuards() {
    if (root.__apCartScrollGuards) return;
    root.__apCartScrollGuards = true;
    var lastTouchX = 0;
    var lastTouchY = 0;

    function scrollContainer(target) {
      return target && target.closest ? target.closest(".ap-cart__body") : null;
    }

    function canScroll(el) {
      return el && el.scrollHeight > el.clientHeight + 1;
    }

    function atTop(el) {
      return el.scrollTop <= 0;
    }

    function atBottom(el) {
      return el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
    }

    root.addEventListener("wheel", function (event) {
      var body = scrollContainer(event.target);
      if (!body) return;
      event.stopPropagation();
      if (!canScroll(body)) {
        event.preventDefault();
        return;
      }
      body.scrollTop += event.deltaY;
      event.preventDefault();
      if ((event.deltaY < 0 && atTop(body)) || (event.deltaY > 0 && atBottom(body))) {
        event.preventDefault();
      }
    }, { passive: false, capture: true });

    root.addEventListener("touchstart", function (event) {
      if (!scrollContainer(event.target) || !event.touches || !event.touches.length) return;
      lastTouchX = event.touches[0].clientX;
      lastTouchY = event.touches[0].clientY;
    }, { passive: true, capture: true });

    root.addEventListener("touchmove", function (event) {
      var body = scrollContainer(event.target);
      if (!body || !event.touches || !event.touches.length) return;
      var currentX = event.touches[0].clientX;
      var currentY = event.touches[0].clientY;
      var deltaX = lastTouchX - currentX;
      var deltaY = lastTouchY - currentY;
      lastTouchX = currentX;
      lastTouchY = currentY;
      var track = event.target.closest(".ap-cart__recs-track");
      if (track && track.scrollWidth > track.clientWidth + 1 && Math.abs(deltaX) > Math.abs(deltaY)) return;
      event.stopPropagation();
      if (!canScroll(body)) {
        event.preventDefault();
        return;
      }
      if ((deltaY < 0 && atTop(body)) || (deltaY > 0 && atBottom(body))) {
        event.preventDefault();
      }
    }, { passive: false, capture: true });
  }

  function fetchCart() {
    if (state.cartFetch) return state.cartFetch;
    state.cartFetch = api(localePath("/cart.js") + "?ap_cart=1&t=" + Date.now()).then(function (cart) {
      var changed = JSON.stringify(state.cart) !== JSON.stringify(cart);
      state.cart = cart;
      if (changed) render(cart);
      return cart;
    }).catch(function () {}).finally(function () {
      state.cartFetch = null;
    });
    return state.cartFetch;
  }

  function scheduleCartRefresh(delay) {
    window.clearTimeout(state.refreshTimer);
    state.refreshTimer = window.setTimeout(function () {
      fetchCart().then(bridgeLoyaltyWidget);
    }, delay == null ? 120 : delay);
  }

  function changeLine(key, quantity, removedItem) {
    var removedIndex = state.cart ? state.cart.items.findIndex(function (item) { return item.key === key; }) : 0;
    var minis = quantity <= 0 ? tbMinisOf(key) : [], updates = {};
    if (minis.length) { updates[key] = 0; minis.forEach(function (m) { updates[m.key] = 0; }); if (removedItem) removedItem = Object.assign({}, removedItem, { __tbMinis: minis }); }
    return api(localePath(minis.length ? "/cart/update.js" : "/cart/change.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(minis.length ? { updates: updates } : { id: key, quantity: Math.max(0, quantity) })
    }).then(function (cart) {
      if (removedItem) showRemovalNotice(removedItem, removedIndex);
      state.cart = cart;
      clearError();
      render(cart);
      document.dispatchEvent(new CustomEvent("ap-cart:updated", { bubbles: true, detail: cart }));
      return cart;
    });
  }

  function updateCart(payload) {
    return api(localePath("/cart/update.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (cart) {
      state.cart = cart;
      clearError();
      render(cart);
      document.dispatchEvent(new CustomEvent("ap-cart:updated", { bubbles: true, detail: cart }));
      return cart;
    });
  }

  function addVariant(variantId, quantity, properties, sellingPlan) {
    var item = {
      id: Number(variantId),
      quantity: quantity || 1,
      properties: properties || {}
    };
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    return api(localePath("/cart/add.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [item]
      })
    }).then(function () {
      clearError();
      return fetchCart();
    });
  }

  function addCartItems(items) {
    return api(localePath("/cart/add.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    });
  }

  function updateCartLines(updates) {
    return api(localePath("/cart/update.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates })
    });
  }

  function oilSize(value) {
    var source = String(value || "");
    var metric = source.match(/(30|60|120|240)\s*ml/i);
    if (metric) return Number(metric[1]);
    var ounces = source.match(/(1|2|4|8)\s*oz/i);
    if (!ounces) return 0;
    return { 1: 30, 2: 60, 4: 120, 8: 240 }[Number(ounces[1])] || 0;
  }

  function oilSizeLabel(value) {
    var source = String(value || "");
    var metric = source.match(/(30|60|120|240)\s*ml/i);
    if (metric) return Number(metric[1]) + "ml";
    var ounces = source.match(/(1|2|4|8)\s*oz/i);
    return ounces ? Number(ounces[1]) + "oz" : "";
  }

  function isMultiPackOilVariant(value) {
    return /(?:[2-9]|\d{2,})\s*[- ]?pack/i.test(String(value || ""));
  }

  function nextOilSize(size) {
    if (size === 30) return 60;
    if (size === 60) return 120;
    if (size === 120) return 240;
    return 0;
  }

  function cartItemHandle(item) {
    if (item && item.handle) return String(item.handle);
    var match = String(item && item.url || "").match(/\/products\/([^?/#]+)/i);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function looksLikeWaterlessOil(item) {
    if (!item) return false;
    var addon = String(item.properties && item.properties._addon || "");
    var identity = [cartItemHandle(item), item.product_title, item.title, addon].join(" ");
    return /waterless.+fragrance.+oil|fragrance.+oil.+waterless/i.test(identity);
  }

  function looksLikeSizeUpgradeableOil(item) {
    if (!item) return false;
    var identity = [cartItemHandle(item), item.product_type, item.product_title, item.title].join(" ");
    var looksLikeOil = looksLikeWaterlessOil(item) || /fragrance.+oil|essential.+oil/i.test(identity);
    return looksLikeOil && (!state.bundleGroupsLoaded || isFragranceOilOfferGroup(bundleGroupKeyForItem(item)));
  }

  function preliminarySizeUpgradeItems(cart) {
    return eligibleItems(cart).filter(function (item) {
      var variantTitle = item.variant_title || item.title;
      return looksLikeSizeUpgradeableOil(item) && !isMultiPackOilVariant(variantTitle) && nextOilSize(oilSize(variantTitle));
    });
  }

  function sizeUpgradeProductUrl(handle) {
    return localePath("/products/" + encodeURIComponent(handle) + ".js");
  }

  function loadSizeUpgradeProducts(cart) {
    var handles = preliminarySizeUpgradeItems(cart).map(cartItemHandle).filter(Boolean);
    var pending = handles.map(function (handle) {
      if (Object.prototype.hasOwnProperty.call(state.sizeUpgradeProducts, handle)) {
        return Promise.resolve(state.sizeUpgradeProducts[handle]);
      }
      if (state.sizeUpgradeLoading[handle]) return state.sizeUpgradeLoading[handle];
      state.sizeUpgradeLoading[handle] = fetch(sizeUpgradeProductUrl(handle), {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).catch(function () {
        return null;
      }).then(function (product) {
        state.sizeUpgradeProducts[handle] = product;
        delete state.sizeUpgradeLoading[handle];
        return product;
      });
      return state.sizeUpgradeLoading[handle];
    });
    return Promise.all(pending).then(function () {
      if (state.cart) renderSizeUpgrade(state.cart);
    });
  }

  function sizeUpgradeProperties(item, targetSize) {
    var properties = Object.assign({}, item.properties || {});
    if (/^Waterless fragrance oil\s+\d+\s*ml$/i.test(String(properties._addon || ""))) {
      properties._addon = "Waterless fragrance oil " + targetSize + "ml";
    }
    return properties;
  }

  function sizeUpgradePropertiesKey(properties) {
    return Object.keys(properties || {}).sort().map(function (key) {
      return JSON.stringify([key, String(properties[key])]);
    }).join("|");
  }

  function sizeUpgradeIdentity(variantId, properties) {
    return String(variantId) + "::" + sizeUpgradePropertiesKey(properties);
  }

  function sizeUpgradeIdentityEntry(variantId, properties) {
    return {
      identity: sizeUpgradeIdentity(variantId, properties),
      variantId: Number(variantId),
      properties: Object.assign({}, properties || {}),
      quantity: 0
    };
  }

  function sizeUpgradeIdentityItems(cart, entry) {
    return (cart.items || []).filter(function (item) {
      return sizeUpgradeIdentity(item.variant_id, item.properties) === entry.identity;
    });
  }

  function sizeUpgradeIdentityQuantity(cart, entry) {
    return sizeUpgradeIdentityItems(cart, entry).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  function sizeUpgradeEntriesMatch(cart, entries) {
    return (entries || []).every(function (entry) {
      return sizeUpgradeIdentityQuantity(cart, entry) === Number(entry.quantity || 0);
    });
  }

  function sizeUpgradePlan(cart) {
    if (!state.bundleGroupsLoaded) return null;
    var cartItems = eligibleItems(cart);
    var lines = [];
    var excluded = { max: 0, unavailable: 0, special: 0, total: 0 };
    cartItems.forEach(function (item) {
      var groupKey = bundleGroupKeyForItem(item);
      if (!isFragranceOilOfferGroup(groupKey)) return;
      var fromSize = oilSize(item.variant_title || item.title);
      if (!fromSize) return;
      var itemQuantity = Number(item.quantity || 0);
      if (isMultiPackOilVariant(item.variant_title || item.title) || item.selling_plan_allocation || (item.properties && item.properties._bundle_items_json)) {
        excluded.special += itemQuantity;
        return;
      }
      var toSize = nextOilSize(fromSize);
      if (!toSize) {
        excluded.max += itemQuantity;
        return;
      }
      var handle = cartItemHandle(item);
      var product = state.sizeUpgradeProducts[handle];
      if (!product || !product.variants) {
        excluded.unavailable += itemQuantity;
        return;
      }
      var target = product.variants.find(function (variant) {
        return variant && variant.available !== false && !isMultiPackOilVariant(variant.title) && oilSize(variant.title) === toSize;
      });
      if (!target) {
        excluded.unavailable += itemQuantity;
        return;
      }
      var targetProperties = sizeUpgradeProperties(item, toSize);
      var quantity = itemQuantity;
      var original = Number(item.original_line_price || item.line_price || 0);
      var current = Number(item.final_line_price != null ? item.final_line_price : item.line_price || 0);
      var discountFactor = original > 0 ? current / original : 1;
      var targetOriginal = normalizePrice(target.price) * quantity;
      var targetFinal = Math.round(targetOriginal * discountFactor);
      lines.push({
        key: item.key,
        groupKey: groupKey,
        productId: item.product_id,
        productTitle: item.product_title || item.title,
        fromVariantId: item.variant_id,
        toVariantId: target.id,
        fromSize: fromSize,
        toSize: toSize,
        fromSizeLabel: oilSizeLabel(item.variant_title || item.title) || (fromSize + "ml"),
        toSizeLabel: oilSizeLabel(target.title) || (toSize + "ml"),
        quantity: quantity,
        fromProperties: Object.assign({}, item.properties || {}),
        toProperties: targetProperties,
        fromIdentity: sizeUpgradeIdentity(item.variant_id, item.properties),
        toIdentity: sizeUpgradeIdentity(target.id, targetProperties),
        currentFinal: current,
        currentOriginal: original,
        targetFinal: targetFinal,
        targetOriginal: targetOriginal,
        discountFactor: discountFactor
      });
    });
    excluded.total = excluded.max + excluded.unavailable + excluded.special;
    if (!lines.length) return null;
    var affected = {};
    lines.forEach(function (line) {
      if (!affected[line.fromIdentity]) affected[line.fromIdentity] = sizeUpgradeIdentityEntry(line.fromVariantId, line.fromProperties);
      if (!affected[line.toIdentity]) affected[line.toIdentity] = sizeUpgradeIdentityEntry(line.toVariantId, line.toProperties);
    });
    var snapshot = Object.keys(affected).map(function (identity) {
      var entry = affected[identity];
      entry.quantity = sizeUpgradeIdentityQuantity(cart, entry);
      return entry;
    });
    var desiredByIdentity = {};
    snapshot.forEach(function (entry) {
      desiredByIdentity[entry.identity] = Object.assign({}, entry, { properties: Object.assign({}, entry.properties) });
    });
    lines.forEach(function (line) {
      desiredByIdentity[line.fromIdentity].quantity -= line.quantity;
      desiredByIdentity[line.toIdentity].quantity += line.quantity;
    });
    var desired = Object.keys(desiredByIdentity).map(function (identity) {
      return desiredByIdentity[identity];
    });
    var quantity = lines.reduce(function (sum, line) { return sum + line.quantity; }, 0);
    var currentTotal = lines.reduce(function (sum, line) { return sum + line.currentFinal; }, 0);
    var targetTotal = lines.reduce(function (sum, line) { return sum + line.targetFinal; }, 0);
    var currentVolume = lines.reduce(function (sum, line) { return sum + (line.fromSize * line.quantity); }, 0);
    var targetVolume = lines.reduce(function (sum, line) { return sum + (line.toSize * line.quantity); }, 0);
    var currentPerMl = currentVolume > 0 ? currentTotal / currentVolume : 0;
    var targetPerMl = targetVolume > 0 ? targetTotal / targetVolume : 0;
    var extraVolume = Math.max(0, targetVolume - currentVolume);
    var delta = targetTotal - currentTotal;
    var regularSavings = lines.reduce(function (sum, line) {
      return sum + Math.max(0, (line.currentOriginal * 2) - line.targetOriginal);
    }, 0);
    var lineDiscountPercents = lines.map(function (line) {
      return line.currentOriginal > 0 ? Math.max(0, Math.round((1 - (line.currentFinal / line.currentOriginal)) * 100)) : 0;
    });
    var hasDiscount = lineDiscountPercents.some(function (percent) { return percent > 0; });
    var commonDiscountPercent = lineDiscountPercents.length && lineDiscountPercents.every(function (percent) {
      return percent === lineDiscountPercents[0];
    }) ? lineDiscountPercents[0] : 0;
    return {
      lines: lines,
      quantity: quantity,
      currentTotal: currentTotal,
      targetTotal: targetTotal,
      delta: delta,
      extraVolume: extraVolume,
      regularSavings: regularSavings,
      unitSavingsPercent: currentPerMl > 0 ? Math.max(0, Math.round((1 - (targetPerMl / currentPerMl)) * 100)) : 0,
      discountPercent: commonDiscountPercent,
      hasDiscount: hasDiscount,
      excluded: excluded,
      totalQuantity: quantity + excluded.total,
      snapshot: snapshot,
      desired: desired,
      sameMove: lines.every(function (line) {
        return line.fromSize === lines[0].fromSize && line.toSize === lines[0].toSize && line.toSizeLabel === lines[0].toSizeLabel;
      })
    };
  }

  function shortOilTitle(value) {
    return String(value || "Fragrance oil")
      .split(/\s+Inspired\b/i)[0]
      .split(/\s+[–-]\s+/)[0]
      .replace(/\s+Waterless Fragrance Oil.*$/i, "")
      .trim();
  }

  function sizeUpgradeDetailTitle(value) {
    var title = shortOilTitle(value).replace(/\s+Perfume$/i, "").trim();
    if (title.length > 28) title = title.replace(/\s+by\s+.+$/i, "").trim();
    return title || text("fragrance_oil", "Fragrance oil");
  }

  function sizeUpgradeDelta(value) {
    if (value <= 0) return text("included", "Included");
    return "+" + money(value);
  }

  function renderSizeUpgradeSkeleton(mount, count) {
    mount.hidden = false;
    mount.className = "ap-cart__size-upgrade is-loading";
    mount.innerHTML = [
      '<div class="ap-cart__size-upgrade-skeleton" aria-label="' + escapeHtml(text("checking_size_upgrades", "Checking size upgrades")) + '">',
        '<span></span><i></i><b></b>',
      '</div>'
    ].join("");
    mount.setAttribute("data-candidate-count", String(count || 0));
  }

  function renderSizeUpgradeSuccess(mount, success) {
    var successTitle = success.quantity === 1
      ? text("bottle_doubled", "Bottle doubled")
      : formatText("bottles_doubled", "__COUNT__ bottles doubled", { count: success.quantity });
    var successCopy = success.toSizeLabel
      ? formatText("bottles_now_size", "Now __SIZE__", { size: success.toSizeLabel })
      : text("bottles_next_sizes", "Next bottle sizes");
    if (success.discountPercent > 0) {
      successCopy += " · " + formatText("discount_still_applies", "__PERCENT__% discount still applies", { percent: success.discountPercent });
    } else if (success.hasDiscount) {
      successCopy += " · " + text("existing_savings_still_apply", "Existing savings still apply");
    }
    var plan = state.sizeUpgradeUndo && state.sizeUpgradeUndo.plan;
    var expanded = Boolean(state.sizeUpgradeExpanded && plan);
    var reviewId = "ap-cart-size-upgrade-success-review";
    mount.hidden = false;
    mount.className = "ap-cart__size-upgrade is-success" + (expanded ? " is-expanded" : "");
    mount.innerHTML = [
      '<div class="ap-cart__size-upgrade-success">',
        '<div class="ap-cart__size-upgrade-success-line"><strong>' + escapeHtml(successTitle) + '</strong><button type="button" data-ap-cart-size-upgrade-undo>' + escapeHtml(text("undo", "Undo")) + '</button></div>',
        '<div class="ap-cart__size-upgrade-success-line"><small>' + escapeHtml(successCopy) + '</small>' + (plan ? '<button class="ap-cart__size-upgrade-success-review" type="button" data-ap-cart-size-upgrade-review aria-expanded="' + (expanded ? "true" : "false") + '" aria-controls="' + reviewId + '">' + escapeHtml(text("details", "Details")) + '</button>' : '') + '</div>',
      '</div>',
      plan ? sizeUpgradeDetailsHtml(plan, reviewId, expanded) : ""
    ].join("");
  }

  function sizeUpgradeDetailsHtml(plan, reviewId, expanded) {
    var exclusionNotes = [];
    if (plan.excluded.max) exclusionNotes.push(formatText("bottles_already_largest", "__COUNT__ already largest", { count: plan.excluded.max }));
    if (plan.excluded.unavailable) exclusionNotes.push(formatText("bottle_size_unavailable", "__COUNT__ next size unavailable", { count: plan.excluded.unavailable }));
    if (plan.excluded.special) exclusionNotes.push(formatText("bottles_special_unchanged", "__COUNT__ bundle or subscription unchanged", { count: plan.excluded.special }));
    var trust = plan.discountPercent > 0
      ? formatText("discount_still_applies", "__PERCENT__% discount still applies", { percent: plan.discountPercent })
      : plan.hasDiscount
        ? text("existing_savings_still_apply", "Existing savings still apply")
        : text("bundle_pricing_recalculates", "Bundle pricing recalculates automatically");
    var detailFacts = exclusionNotes.concat([
      formatText("save_regular_price", "Save __AMOUNT__", { amount: money(plan.regularSavings) }) + " vs same volume",
      formatText("added_volume", "+__VOLUME__ml total", { volume: Math.round(plan.extraVolume) }),
      trust
    ]);
    return [
      '<div class="ap-cart__size-upgrade-list" id="' + reviewId + '"' + (expanded ? "" : " hidden") + '>',
        plan.lines.map(function (line) {
          var quantityLabel = line.quantity > 1 ? " ×" + line.quantity : "";
          return '<div><span>' + escapeHtml(sizeUpgradeDetailTitle(line.productTitle) + quantityLabel) + '</span><strong>' + escapeHtml(line.fromSizeLabel + " → " + line.toSizeLabel) + '</strong></div>';
        }).join(""),
        '<p>' + escapeHtml(detailFacts.join(" · ")) + '</p>',
      '</div>'
    ].join("");
  }

  function renderSizeUpgrade(cart) {
    var mount = root.querySelector("[data-ap-cart-size-upgrade]");
    if (!mount) return;
    var candidates = preliminarySizeUpgradeItems(cart);
    if (!candidates.length) {
      mount.hidden = true;
      mount.innerHTML = "";
      return;
    }
    if (!root.classList.contains("is-open")) {
      mount.hidden = true;
      mount.innerHTML = "";
      return;
    }
    if (state.sizeUpgradeSuccess) {
      if (sizeUpgradeEntriesMatch(cart, state.sizeUpgradeSuccess.entries)) {
        renderSizeUpgradeSuccess(mount, state.sizeUpgradeSuccess);
        return;
      }
      state.sizeUpgradeSuccess = null;
      state.sizeUpgradeUndo = null;
    }
    if (!state.bundleGroupsLoaded) {
      renderSizeUpgradeSkeleton(mount, candidates.length);
      loadBundleGroups().then(function () { return loadSizeUpgradeProducts(state.cart || cart); });
      return;
    }
    var unloaded = candidates.some(function (item) {
      var handle = cartItemHandle(item);
      return handle && !Object.prototype.hasOwnProperty.call(state.sizeUpgradeProducts, handle);
    });
    if (unloaded) {
      renderSizeUpgradeSkeleton(mount, candidates.length);
      loadSizeUpgradeProducts(cart);
      return;
    }
    var plan = sizeUpgradePlan(cart);
    if (!plan) {
      mount.hidden = true;
      mount.innerHTML = "";
      return;
    }
    var offerTitle = plan.quantity === 1
      ? text("double_your_bottle_size", "Double your bottle size")
      : plan.excluded.total
        ? formatText("double_bottle_size_count", "Double __COUNT__ bottle sizes", { count: plan.quantity })
        : text("double_every_bottle_size", "Double every bottle size");
    var savingsLabel = formatText("save_regular_price", "Save __AMOUNT__", { amount: money(plan.regularSavings) });
    var discountBadge = plan.discountPercent > 0
      ? formatText("discount_applies_short", "__PERCENT__% still applies", { percent: plan.discountPercent })
      : plan.hasDiscount
        ? text("savings_stay", "Savings stay")
        : text("pricing_updates", "Pricing updates");
    var addedCost = plan.delta > 0
      ? formatText("amount_added", "__AMOUNT__ added", { amount: sizeUpgradeDelta(plan.delta) })
      : text("no_added_cost", "No added cost");
    var ctaLabel = plan.quantity === 1
      ? text("upgrade_my_bottle", "Upgrade my bottle")
      : plan.excluded.total
        ? formatText("upgrade_bottles", "Upgrade __COUNT__ bottles", { count: plan.quantity })
        : text("upgrade_all_bottles", "Upgrade all bottles");
    var reviewId = "ap-cart-size-upgrade-review";
    var expanded = state.sizeUpgradeExpanded;
    mount.hidden = false;
    mount.className = "ap-cart__size-upgrade" + (expanded ? " is-expanded" : "") + (state.sizeUpgradeBusy ? " is-busy" : "");
    mount.innerHTML = [
      '<div class="ap-cart__size-upgrade-main">',
        '<div class="ap-cart__size-upgrade-headline"><strong>' + escapeHtml(offerTitle) + '</strong><button class="ap-cart__size-upgrade-review" type="button" data-ap-cart-size-upgrade-review aria-label="' + escapeHtml(formatText("review_size_changes", "Review __COUNT__ size changes", { count: plan.quantity })) + '" aria-expanded="' + (expanded ? "true" : "false") + '" aria-controls="' + reviewId + '">' + escapeHtml(text("details", "Details")) + '</button></div>',
        '<div class="ap-cart__size-upgrade-money"><strong>' + escapeHtml(savingsLabel) + '</strong><span>' + escapeHtml(addedCost) + '<small>' + escapeHtml(discountBadge) + '</small></span></div>',
        '<div class="ap-cart__size-upgrade-action">',
          '<button type="button" data-ap-cart-size-upgrade-all' + (state.sizeUpgradeBusy ? ' disabled aria-busy="true"' : '') + '>',
            state.sizeUpgradeBusy ? '<span class="ap-cart__size-upgrade-loading"><i aria-hidden="true"></i>' + escapeHtml(formatText("upgrading_bottles", "Upgrading __COUNT__…", { count: plan.quantity })) + '</span>' : '<span>' + escapeHtml(ctaLabel) + '</span>',
          '</button>',
        '</div>',
      '</div>',
      sizeUpgradeDetailsHtml(plan, reviewId, expanded)
    ].join("");
    mount.__apSizeUpgradePlan = plan;
    if (!mount.__apSizeUpgradeImpression) {
      mount.__apSizeUpgradeImpression = true;
      trackCartEvent("size_upgrade_impression", {
        eligible_lines: plan.lines.length,
        eligible_quantity: plan.quantity,
        delta_price: plan.delta / 100,
        surface: "upgrade_all"
      });
    }
  }

  function commitCartState(cart) {
    state.cart = cart;
    clearError();
    render(cart);
    document.dispatchEvent(new CustomEvent("ap-cart:updated", { bubbles: true, detail: cart }));
    return cart;
  }

  function sizeUpgradePricePreserved(cart, plan, cartBefore) {
    if (!sizeUpgradeEntriesMatch(cart, plan.desired)) return false;
    var actualDelta = Number(cart.total_price || 0) - Number((cartBefore && cartBefore.total_price) || 0);
    var tolerance = Math.max(50, Math.round(Math.abs(plan.delta) * 0.01));
    return actualDelta <= plan.delta + tolerance;
  }

  function sizeUpgradeCart() {
    return api(localePath("/cart.js") + "?ap_cart=1&t=" + Date.now());
  }

  function reconcileSizeUpgradeEntries(entries) {
    return sizeUpgradeCart().then(function (cart) {
      var additions = [];
      entries.forEach(function (entry) {
        var missing = Math.max(0, Number(entry.quantity || 0) - sizeUpgradeIdentityQuantity(cart, entry));
        if (!missing) return;
        additions.push({
          id: Number(entry.variantId),
          quantity: missing,
          properties: Object.assign({}, entry.properties || {})
        });
      });
      return (additions.length ? addCartItems(additions) : Promise.resolve()).then(sizeUpgradeCart);
    }).then(function (cart) {
      var updates = {};
      entries.forEach(function (entry) {
        var desiredQuantity = Math.max(0, Number(entry.quantity || 0));
        var matches = sizeUpgradeIdentityItems(cart, entry);
        if (!matches.length && desiredQuantity) throw new Error("size_upgrade_target_missing");
        if (sizeUpgradeIdentityQuantity(cart, entry) === desiredQuantity && matches.length <= 1) return;
        matches.forEach(function (item, index) {
          updates[item.key] = index === 0 ? desiredQuantity : 0;
        });
      });
      return (Object.keys(updates).length ? updateCartLines(updates) : Promise.resolve(cart));
    }).then(function (cart) {
      if (!sizeUpgradeEntriesMatch(cart, entries)) throw new Error("size_upgrade_quantity_mismatch");
      return cart;
    });
  }

  function executeSizeUpgrade(plan) {
    if (!plan || state.sizeUpgradeBusy) return;
    var cartBefore = null;
    state.sizeUpgradeBusy = true;
    state.sizeUpgradeExpanded = false;
    renderSizeUpgrade(state.cart || { items: [] });
    setCartMutating(true);
    trackCartEvent("size_upgrade_clicked", {
      eligible_lines: plan.lines.length,
      eligible_quantity: plan.quantity,
      delta_price: plan.delta / 100,
      surface: "upgrade_all"
    });
    sizeUpgradeCart().then(function (cart) {
      cartBefore = cart;
      if (!sizeUpgradeEntriesMatch(cart, plan.snapshot)) throw new Error("cart_changed");
      return reconcileSizeUpgradeEntries(plan.desired);
    }).then(function (cart) {
      if (!sizeUpgradePricePreserved(cart, plan, cartBefore)) {
        throw new Error("discount_lost");
      }
      state.sizeUpgradeUndo = { plan: plan };
      state.sizeUpgradeSuccess = {
        quantity: plan.quantity,
        unchanged: plan.excluded.total,
        toSizeLabel: plan.sameMove && !plan.excluded.total ? plan.lines[0].toSizeLabel : "",
        discountPercent: plan.discountPercent,
        hasDiscount: plan.hasDiscount,
        entries: plan.desired.map(function (entry) {
          return Object.assign({}, entry, { properties: Object.assign({}, entry.properties) });
        })
      };
      commitCartState(cart);
      trackCartEvent("size_upgrade_success", {
        upgraded_lines: plan.lines.length,
        upgraded_quantity: plan.quantity,
        delta_price: plan.delta / 100,
        cart_total_after: Number(cart.total_price || 0) / 100,
        surface: "upgrade_all"
      });
    }).catch(function (error) {
      if (error && error.message === "cart_changed") {
        if (cartBefore) commitCartState(cartBefore);
        trackCartEvent("size_upgrade_error", { reason: "cart_changed", surface: "upgrade_all" });
        showError(text("size_upgrade_cart_changed", "Your cart changed. Review the updated upgrade offer and try again."));
        return;
      }
      var reason = error && error.message === "discount_lost" ? "discount_lost" : "swap_failed";
      return reconcileSizeUpgradeEntries(plan.snapshot).then(function (cart) {
        commitCartState(cart);
        trackCartEvent("size_upgrade_error", { reason: reason, surface: "upgrade_all" });
        showError(reason === "discount_lost"
          ? text("size_upgrade_discount_kept", "The final price was higher than promised, so your cart is unchanged.")
          : text("size_upgrade_error", "Couldn't size up every bottle. Your cart is unchanged."));
      }).catch(function () {
        return fetchCart().then(function () {
          trackCartEvent("size_upgrade_error", { reason: "recovery_failed", surface: "upgrade_all" });
          showError(text("size_upgrade_review_error", "We couldn't verify every size change. Please review your cart."));
        });
      });
    }).finally(function () {
      state.sizeUpgradeBusy = false;
      setCartMutating(false);
      if (state.cart) renderSizeUpgrade(state.cart);
    });
  }

  function undoSizeUpgrade() {
    if (!state.sizeUpgradeUndo || state.sizeUpgradeBusy || !state.cart) return;
    var plan = state.sizeUpgradeUndo.plan;
    state.sizeUpgradeBusy = true;
    setCartMutating(true);
    reconcileSizeUpgradeEntries(plan.snapshot).then(function (cart) {
      state.sizeUpgradeUndo = null;
      state.sizeUpgradeSuccess = null;
      state.sizeUpgradeExpanded = false;
      commitCartState(cart);
      trackCartEvent("size_upgrade_undo", {
        upgraded_lines: plan.lines.length,
        upgraded_quantity: plan.quantity,
        surface: "upgrade_all"
      });
    }).catch(function () {
      showError(text("size_upgrade_undo_error", "We couldn't undo the size change. Please try again."));
      return fetchCart();
    }).finally(function () {
      state.sizeUpgradeBusy = false;
      setCartMutating(false);
    });
  }

  function setCartMutating(mutating) {
    window.clearTimeout(state.mutationTimer);
    root.classList.toggle("is-mutating", !!mutating);
    if (mutating) {
      state.mutationTimer = window.setTimeout(function () {
        root.classList.remove("is-mutating");
      }, 900);
    }
  }

  function closeNativeCartDrawer() {
    var nativeDrawer = document.querySelector("cart-drawer");
    if (!nativeDrawer) return;
    if (typeof nativeDrawer.close === "function") nativeDrawer.close();
    nativeDrawer.classList.remove("active");
    nativeDrawer.removeAttribute("open");
    document.body.classList.remove("overflow-hidden");
  }

  function openCart(options) {
    if (!root.classList.contains("is-enabled")) return;
    closeNativeCartDrawer();
    var wasOpen = root.classList.contains("is-open");
    if (!wasOpen) state.returnFocus = document.activeElement;
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("ap-cart-lock");
    if (state.cart) render(state.cart);
    if (!options || !options.skipRefresh) fetchCart().then(bridgeLoyaltyWidget);
    else bridgeLoyaltyWidget();
    if (!wasOpen) {
      var closeButton = root.querySelector("button[data-ap-cart-close]");
      if (closeButton) closeButton.focus({ preventScroll: true });
    }
    startLoyaltyBridgeLoop();
    if (!wasOpen) trackCartEvent("cart_opened", {
      trigger: options && options.trigger ? options.trigger : ""
    });
    // GA4 standard view_cart (dashboard already has cart_opened above, so GA4 only).
    if (!wasOpen && typeof window.apTrack === "function") {
      // First open on a page can beat the cart fetch: wait for it so value/items are real.
      Promise.resolve(state.cart || fetchCart()).then(function (viewed) {
      viewed = viewed || { items: [] };
      window.apTrack("view_cart", {
        currency: viewed.currency || "USD",
        value: Number(viewed.total_price || 0) / 100,
        items: (viewed.items || []).slice(0, 20).map(function (item) {
          return { item_id: String(item.product_id), item_variant: String(item.variant_id), item_name: item.product_title, price: Number(item.final_price || 0) / 100, quantity: item.quantity };
        })
      }, "cart", { gaOnly: true });
      }).catch(function () {});
    }
  }

  function closeCart() {
    var wasOpen = root.classList.contains("is-open");
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("ap-cart-lock");
    closeNativeCartDrawer();
    window.clearInterval(state.loyaltyTimer);
    if (wasOpen && state.returnFocus && state.returnFocus.isConnected) state.returnFocus.focus({ preventScroll: true });
    if (wasOpen) trackCartEvent("cart_closed");
  }

  function imageUrl(src, width) {
    if (!src) return "";
    if (src.indexOf("//") === 0) src = window.location.protocol + src;
    try {
      var url = new URL(src);
      url.searchParams.set("width", String(width || 220));
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function isProtectionItem(item) {
    var variantId = root.dataset.protectionVariantId;
    if (variantId && item && String(item.variant_id) === String(variantId)) return true;
    var title = String((item && item.product_title) || (item && item.title) || "").toLowerCase();
    return /protected shipping|shipping protection|package protection|free unlimited return|green shipping protection/.test(title);
  }

  function isPriorityPlusItem(item) {
    var variantId = root.dataset.priorityPlusVariantId;
    return Boolean(variantId && item && String(item.variant_id) === String(variantId));
  }

  function eligibleItems(cart) {
    return (cart.items || []).filter(function (item) {
      return !isProtectionItem(item) && !isPriorityPlusItem(item) && !isOrphanGift(item);
    });
  }

  function eligibleCartTotal(cart) {
    return eligibleItems(cart).reduce(function (sum, item) {
      var lineTotal = item.final_line_price != null ? item.final_line_price : item.line_price;
      return sum + Number(lineTotal || 0);
    }, 0);
  }

  // Checkout button "was" price removed sitewide (owner 2026-10-15: "Remove the strikeout price in the cart").

  function cartLineByKey(key) {
    var cart = state.cart || { items: [] };
    for (var i = 0; i < (cart.items || []).length; i += 1) {
      if (cart.items[i].key === key) return cart.items[i];
    }
    return null;
  }

  function recommendationSource(recCard) {
    if (!recCard) return { source: "cart_drawer" };
    var bundleTrack = recCard.closest("[data-ap-cart-bundle-suggestions-track]");
    if (bundleTrack) {
      return {
        source: "bundle_suggestion",
        source_key: bundleTrack.getAttribute("data-ap-cart-bundle-suggestions-track") || ""
      };
    }
    var groupTrack = recCard.closest("[data-ap-cart-group-recs-track]");
    if (groupTrack) {
      return {
        source: "collection_pairing",
        source_key: groupTrack.getAttribute("data-ap-cart-group-recs-track") || ""
      };
    }
    if (recCard.closest("[data-ap-cart-recs-track]")) {
      return { source: "curated_pairing" };
    }
    if (recCard.closest("[data-ap-cart-room-mist-track]")) {
      return {
        source: "room_mist_upsell",
        source_key: ROOM_MIST_UPSELL_HANDLE
      };
    }
    var lineCleaner = recCard.closest("[data-ap-cart-line-cleaner]");
    if (lineCleaner) {
      if (lineCleaner.getAttribute("data-ap-cart-rec") === "fragrance-dropper") {
        return {
          source: "fragrance_dropper_upsell",
          source_key: DROPPER_UPSELL_HANDLE
        };
      }
      if (lineCleaner.getAttribute("data-ap-cart-rec") === "waterless-cleaner") {
        return {
          source: "waterless_cleaner_upsell",
          source_key: WATERLESS_CLEANER_UPSELL_HANDLE
        };
      }
      return {
        source: "humidifying_cleaner_upsell",
        source_key: HUMIDIFYING_CLEANER_UPSELL_HANDLE
      };
    }
    return { source: "recommendation" };
  }

  function trackCartEvent(name, payload) {
    try {
      var cart = state.cart || { items: [] };
      var items = eligibleItems(cart);
      var quantity = items.reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);
      var body = Object.assign({
        visitor_uuid: window.__ap_visitor || "",
        page: window.location.pathname,
        cart_items: quantity,
        cart_line_count: items.length,
        cart_total: Number(cart.total_price || 0) / 100,
        cart_token: cart.token || "",
        drawer_open: root.classList.contains("is-open"),
        via: "ap_cart_drawer"
      }, payload || {});
      if (typeof window.__APEvent === "function") {
        window.__APEvent(name, body);
        return;
      }
      window.setTimeout(function () {
        try {
          if (typeof window.__APEvent === "function") window.__APEvent(name, body);
        } catch (e) {}
      }, 300);
    } catch (e) {}
  }

  // Diffuser Bundle (page diffuser-bundle, mode tier-diffuser): show the same breakdown the builder's last step showed,
  // with the scent names the shopper picked and the diffuser saving, from the hidden _tb_view property (owner 2026-10-15).
  // The visible Item properties stay as they are for the packing slip; they are not repeated here.
  // Minis sets bought with a Diffuser Bundle (owner 2026-10-23): shown inside that bundle's card, priced and saved with it.
  // A set whose bundle is no longer in the cart shows as its own line.
  var tbMinis = {};
  function foldTbMinis(items) {
    var boxes = {};
    if (!document.getElementById("ap-cart-tb-style")) {
      // bundle cards: photo | title | price + stepper, then what's included across the whole card (owner 2026-10-23)
      var st = document.createElement("style"), T = ".ap-cart__item:has(.ap-cart__tb-lines)";
      st.id = "ap-cart-tb-style";
      st.textContent = T + "{grid-template-columns:auto minmax(0,1fr) auto;row-gap:4px}" +
        T + " > .ap-cart__image{grid-area:1 / 1 / 3 / 2}" +
        T + " > .ap-cart__item-main--v2{display:contents}" +
        T + " .ap-cart__item-main--v2 .ap-cart__item-title{grid-area:1 / 2 / 3 / 3;align-self:start}" +
        T + " .ap-cart__item-main--v2 .ap-cart__price-row{grid-area:1 / 3 / 2 / 4;align-self:start}" +
        T + " .ap-cart__item-main--v2 .ap-cart__stepper{grid-area:2 / 3 / 3 / 4;align-self:start}" +
        T + " .ap-cart__item-main--v2 .ap-cart__line-meta{grid-area:3 / 1 / 4 / -1;margin-top:6px}" +
        T + " .ap-cart__item-main--v2 > :not(.ap-cart__item-title):not(.ap-cart__line-meta):not(.ap-cart__line-foot){grid-column:1 / -1}" +
        T + "{grid-template-columns:44px minmax(0,1fr) auto auto;column-gap:10px;align-items:center}" +
        T + " > .ap-cart__image{grid-area:1 / 1 / 2 / 2;width:44px;height:44px;border-radius:9px}" +
        T + " .ap-cart__item-main--v2 .ap-cart__item-title{grid-area:1 / 2 / 2 / 3;align-self:center;margin:0}" +
        T + " .ap-cart__item-main--v2 .ap-cart__price-row{grid-area:1 / 3 / 2 / 4;align-self:center;flex-direction:column;align-items:flex-end;gap:0;line-height:1.1}" +
        T + " .ap-cart__item-main--v2 .ap-cart__compare{font-size:12px}" +
        T + " .ap-cart__item-main--v2 .ap-cart__stepper{grid-area:1 / 4 / 2 / 5;align-self:center}" +
        T + " .ap-cart__item-main--v2 .ap-cart__line-meta{grid-area:2 / 1 / 3 / -1}" +
        ".ap-cart__tb-lines{display:grid;gap:6px;margin:0;padding:8px 0 8px 10px;border-radius:14px;background:#fff;box-shadow:inset 0 0 0 1px rgba(167,123,34,.2)}" +
        ".ap-cart__tb-row{display:grid;grid-template-columns:62px minmax(0,1fr);align-items:center;gap:8px}" +
        ".ap-cart__tb-k{margin:0;font:800 10px/1.15 Lato,sans-serif;letter-spacing:.08em;text-transform:uppercase;color:#7a5a14}" +
        ".ap-cart__tb-k span{display:block;margin-top:1px;font-weight:600;letter-spacing:0;text-transform:none;font-size:10.5px;color:#8a8076}" +
        ".ap-cart__tb-rail{display:flex;gap:5px;margin:0;padding:0 18px 0 0;list-style:none;overflow-x:auto;overscroll-behavior-x:contain;scroll-snap-type:x proximity;scrollbar-width:none;-webkit-overflow-scrolling:touch;-webkit-mask-image:linear-gradient(90deg,#000 calc(100% - 18px),transparent);mask-image:linear-gradient(90deg,#000 calc(100% - 18px),transparent)}" +
        ".ap-cart__tb-rail::-webkit-scrollbar{display:none}" +
        ".ap-cart__tb-rail{flex-wrap:wrap;overflow:visible;padding-right:0;-webkit-mask-image:none;mask-image:none}" +
        ".ap-cart__tb-acc{min-width:0;margin-right:10px}" +
        ".ap-cart__tb-acc>summary{display:flex;align-items:center;gap:8px;min-height:32px;padding:3px 10px 3px 3px;border-radius:999px;background:#f7f0e1;box-shadow:inset 0 0 0 1px rgba(167,123,34,.2);cursor:pointer;list-style:none;-webkit-tap-highlight-color:transparent}" +
        ".ap-cart__tb-acc>summary::-webkit-details-marker{display:none}.ap-cart__tb-acc>summary::marker{content:''}" +
        ".ap-cart__tb-acc>summary:focus-visible{outline:2px solid #a77b22;outline-offset:2px}" +
        ".ap-cart__tb-stack{display:flex;flex:none}" +
        ".ap-cart__tb-stack img,.ap-cart__tb-stack i,.ap-cart__tb-alist img,.ap-cart__tb-alist i{flex:none;width:26px;height:26px;border-radius:50%;object-fit:cover;background:#efe3c8;box-shadow:0 0 0 2px #f7f0e1}" +
        ".ap-cart__tb-stack>*+*{margin-left:-9px}" +
        ".ap-cart__tb-stack i,.ap-cart__tb-alist i{display:grid;place-items:center;font:400 12px/1 Prata,Georgia,serif;font-style:normal;color:#7a5a14}" +
        ".ap-cart__tb-sum{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font:700 12px/1.2 Lato,sans-serif;color:#2c2622}" +
        ".ap-cart__tb-chev{flex:none;width:14px;height:14px;fill:none;stroke:#a77b22;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;transition:transform .2s ease}" +
        ".ap-cart__tb-acc[open] .ap-cart__tb-chev{transform:rotate(180deg)}" +
        ".ap-cart__tb-alist{display:grid;gap:6px;margin:8px 0 2px;padding:0 0 0 4px;list-style:none}" +
        ".ap-cart__tb-alist li{display:flex;align-items:center;gap:8px;margin:0;list-style:none;font:700 12.5px/1.25 Lato,sans-serif;color:#2c2622}.ap-cart__tb-alist li::marker{content:''}" +
        ".ap-cart__tb-alist li img,.ap-cart__tb-alist li i{box-shadow:0 0 0 1px rgba(167,123,34,.25)}" +
        ".ap-cart__tb-alist b{font-weight:800;color:#a77b22}" +
        ".ap-cart__tb-an{display:block;min-width:0}.ap-cart__tb-an small{display:block;margin-top:1px;font:600 11px/1.3 Lato,sans-serif;color:#8a8076}" +
        T + "{margin:4px 0 0;padding:12px;border-radius:18px;background:#fff;box-shadow:inset 0 0 0 1px rgba(167,123,34,.24),0 10px 24px -20px rgba(60,40,10,.55);border-top:0!important}" +
        T + "+*,* + " + T + "{margin-top:12px}" +
        T + " .ap-cart__tb-lines{margin:4px 0 0;padding:10px 0 0;border-radius:0;background:none;box-shadow:none;border-top:1px solid rgba(167,123,34,.16)}" +
        T + " .ap-cart__tb-acc{margin-right:0}" + T + " .ap-cart__tb-save{margin-right:0}" +
        T + " .ap-cart__tb-rail{padding-right:12px}" +
        ".ap-cart__tb-two{margin-top:8px!important}" +
        ".ap-cart__tb-row:has(.ap-cart__tb-acc[open]){align-items:start}.ap-cart__tb-row:has(.ap-cart__tb-acc[open]) .ap-cart__tb-k{padding-top:6px}" +
        "@media (prefers-reduced-motion:reduce){.ap-cart__tb-chev{transition:none}}" +
        ".ap-cart__tb-pl{flex:none;display:inline-flex;align-items:center;gap:6px;margin:0;padding:3px 10px 3px 3px;border-radius:999px;background:#f7f0e1;box-shadow:inset 0 0 0 1px rgba(167,123,34,.2);list-style:none;scroll-snap-align:start;white-space:nowrap}.ap-cart__tb-pl::marker{content:''}" +
        ".ap-cart__tb-pl img,.ap-cart__tb-pl>i{flex:none;width:26px;height:26px;border-radius:50%;object-fit:cover;background:#efe3c8}" +
        ".ap-cart__tb-pl>i{display:grid;place-items:center;font:400 12px/1 Prata,Georgia,serif;font-style:normal;color:#7a5a14}" +
        ".ap-cart__tb-pl span{font:700 12px/1.2 Lato,sans-serif;color:#2c2622}" +
        ".ap-cart__tb-pl b{font:800 11.5px/1 Lato,sans-serif;color:#a77b22}.ap-cart__tb-pl small{font:600 11px/1 Lato,sans-serif;color:#8a8076}" +
        ".ap-cart__tb-tag{display:inline-block;padding:2px 7px;border-radius:999px;background:#a77b22;font:800 10.5px/1.3 Lato,sans-serif;font-style:normal;letter-spacing:0;color:#fffdf8}" +
        ".ap-cart__tb-save{display:flex;align-items:center;gap:7px;margin:2px 10px 0 0;padding-top:8px;border-top:1px dashed rgba(167,123,34,.35);color:#7a4a12}" +
        ".ap-cart__tb-save svg{flex:none;width:16px;height:16px;fill:#a77b22}" +
        ".ap-cart__tb-save>span{display:flex;flex-wrap:wrap;align-items:baseline;gap:0 8px;min-width:0}" +
        ".ap-cart__tb-save strong{font:800 13px/1.3 Lato,sans-serif}.ap-cart__tb-save strong em{font-style:normal;font-weight:700}" +
        ".ap-cart__tb-save small{font:600 10.5px/1.3 Lato,sans-serif;color:#8a7a62}" +
        // action row at the foot of the bundle card (owner 2026-10-28): three quiet text actions split by gold hairlines
        // the cart's ".ap-cart__line-meta > :last-child{margin-bottom:0}" would cancel the pull to the card edge, so this selector outranks it
        ".ap-cart__item-main--v2 .ap-cart__line-meta > .ap-cart__tb-acts{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));margin:10px -12px -12px;border-top:1px solid rgba(167,123,34,.16)}" +
        ".ap-cart__tb-act{display:flex;align-items:center;justify-content:center;gap:6px;min-height:42px;padding:0 4px;color:#13234a;text-decoration:none;font:800 12px/1.1 Lato,sans-serif;letter-spacing:.01em;white-space:nowrap;-webkit-tap-highlight-color:transparent;transition:background-color .15s ease}" +
        ".ap-cart__tb-act+.ap-cart__tb-act{box-shadow:inset 1px 0 0 rgba(167,123,34,.16)}" +
        ".ap-cart__tb-act:first-child{border-bottom-left-radius:18px}.ap-cart__tb-act:last-child{border-bottom-right-radius:18px}" +
        ".ap-cart__tb-act svg{flex:none;width:15px;height:15px;fill:none;stroke:#a77b22;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}" +
        ".ap-cart__tb-act:hover{background:#fbf6ea}.ap-cart__tb-act:active{background:#f5ead2}" +
        ".ap-cart__tb-act:focus-visible{outline:2px solid #a77b22;outline-offset:-2px}" +
        "@media (max-width:340px){.ap-cart__tb-act{gap:4px;font-size:11.5px}.ap-cart__tb-act svg{width:13px;height:13px}}" +
        ".ap-cart__tb-acts[aria-busy=true] .ap-cart__tb-act{opacity:.4;pointer-events:none}.ap-cart__tb-acts[aria-busy=true] .ap-cart__tb-act.is-busy{opacity:1}" +
        ".ap-cart__tb-act.is-busy svg{animation:apTbSpin .9s linear infinite}@keyframes apTbSpin{to{transform:rotate(360deg)}}" +
        T + ".is-tb-fresh{animation:apTbFresh 1.8s ease-out}" +
        "@keyframes apTbFresh{0%,35%{box-shadow:inset 0 0 0 2px #a77b22,0 0 0 5px rgba(167,123,34,.18),0 10px 24px -20px rgba(60,40,10,.55)}}" +
        "";
      document.head.appendChild(st);
      if (root) root.addEventListener("toggle", function (e) { var d = e.target; if (d && d.matches && d.matches("[data-tb-acc]")) tbAccOpen[d.getAttribute("data-tb-acc")] = d.open; }, true);
    }
    tbMinis = {};
    items.forEach(function (it) { if (it.properties && it.properties._bundle_mode === "tier-diffuser") boxes[String(it.variant_id)] = true; });
    return items.filter(function (it) {
      var p = it.properties || {}, box = String(p._tb_box || "");
      if (p._tb_addon !== "minis" || !boxes[box]) return true;
      (tbMinis[box] = tbMinis[box] || []).push(it);
      return false;
    });
  }
  function tbMinisInfo(item) {
    var lines = tbMinis[String(item.variant_id)] || [], finalC = 0, saveC = 0;
    lines.forEach(function (m) {
      var was = Math.round(Number((m.properties || {})._tb_was) * 100) * (m.quantity || 1);
      finalC += Number(m.final_line_price || 0);
      if (was > 0) saveC += Math.max(0, was - Number(m.final_line_price || 0));
    });
    return { lines: lines, finalC: finalC, saveC: saveC };
  }
  // The bundle's whole saving, in cents: diffuser + second-box 10% + minis.
  function tbSaveC(item, view, mi) {
    var qty = item.quantity || 1;
    return Math.round((Number(view.saved) || 0) * 100 * qty) + Math.round((Number(view.asaved) || 0) * 100 * qty) + (view.second ? Math.round((Number(view.second.extra) || 0) * 100 * qty) : 0) + mi.saveC;
  }
  function tbBundlePriceHtml(item) {
    var view = tbView(item), mi = tbMinisInfo(item);
    if (!view || !view.diffuser) return "";
    var finalC = Number(item.final_line_price || 0) + mi.finalC;
    var sv = tbSaveC(item, view, mi);
    return '<div class="ap-cart__price-row"><span class="ap-cart__price">' + moneyCents(finalC) + "</span>" + (sv > 0 ? '<span class="ap-cart__compare">' + moneyCents(finalC + sv) + "</span>" : "") + "</div>";
  }
  // Removing a bundle takes its minis with it (they can't be edited on their own); Undo restores them together.
  function tbMinisOf(key) {
    var items = (state.cart && state.cart.items) || [], line = items.filter(function (it) { return it.key === key; })[0];
    if (!line || !line.properties || line.properties._bundle_mode !== "tier-diffuser") return [];
    return items.filter(function (it) { var p = it.properties || {}; return p._tb_addon === "minis" && String(p._tb_box) === String(line.variant_id); });
  }

  var TB_SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9z"/><path d="M19 15l.8 2.2 2.2.8-2.2.8L19 21l-.8-2.2-2.2-.8 2.2-.8z"/></svg>';
  // Scents accordion (owner 2026-10-23): one line closed, the full list open; open state kept per bundle line.
  var tbAccOpen = {};
  function tbScentAccordion(item, scents) {
    var face = function (src, name) {
      return src ? '<img src="' + escapeHtml(imageUrl(src, 96)) + '" alt="" loading="lazy" width="26" height="26">' : '<i aria-hidden="true">' + escapeHtml(String(name || "?").charAt(0)) + "</i>";
    };
    var names = scents.map(function (sc) { return sc.p + (sc.q > 1 ? " ×" + sc.q : ""); });
    var sum = names[0] + (names.length > 1 ? " +" + (names.length - 1) + " more" : "");
    return '<details class="ap-cart__tb-acc" data-tb-acc="' + escapeHtml(item.key) + '"' + (tbAccOpen[item.key] ? " open" : "") + ">" +
      '<summary aria-label="' + escapeHtml(names.join(", ")) + ', show the list"><span class="ap-cart__tb-stack" aria-hidden="true">' +
        scents.slice(0, 4).map(function (sc) { return face(sc.i, sc.p); }).join("") + "</span>" +
        '<span class="ap-cart__tb-sum">' + escapeHtml(sum) + "</span>" +
        '<svg class="ap-cart__tb-chev" viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6l4 4 4-4"/></svg></summary>' +
      '<ul class="ap-cart__tb-alist">' + scents.map(function (sc) {
        // "Inspired by" only for scents that have one (owner 2026-10-27): the builder sends ib; older lines skip Nature-style names
        var insp = sc.ib != null ? String(sc.ib || "") : (sc.n && sc.n !== sc.p && String(sc.n).indexOf(sc.p) < 0 && String(sc.n).length <= 40 && !/ by |inspired|premium/i.test(sc.n) ? String(sc.n) : "");
        return "<li>" + face(sc.i, sc.p) + '<span class="ap-cart__tb-an">' + escapeHtml(sc.p) + (sc.q > 1 ? " <b>×" + sc.q + "</b>" : "") +
          (insp ? "<small>Inspired by " + escapeHtml(insp) + "</small>" : "") + "</span></li>";
      }).join("") + "</ul></details>";
  }
  // Add-ons inside a Diffuser Bundle (owner 2026-10-23: show them like the diffuser): read from the line's own item list.
  var TB_ADDONS = {
    "53179679932597": { name: "Mini Funnel", img: "https://cdn.shopify.com/s/files/1/0658/4644/4213/files/mini-waterless-funnel-shopify-packshot-nano-banana-pro-2k-v4.png?v=1788134220" },
    "52157222846645": { name: "Cleaner", img: "https://cdn.shopify.com/s/files/1/0658/4644/4213/files/task_01ker3rq13fst870jyzwbe90s8_2F1768188344_img_0.webp?v=1768188877" },
    "52990415372469": { name: "Cleaner 3-Pack", img: "https://cdn.shopify.com/s/files/1/0658/4644/4213/files/task_01ker3rq13fst870jyzwbe90s8_2F1768188344_img_0.webp?v=1768188877" }
  };
  function tbAddons(item) {
    var its = [];
    try { its = JSON.parse(((item.properties || {})._bundle_items_json) || "[]"); } catch (e) { its = []; }
    return its.filter(function (it) { return TB_ADDONS[String(it.variant_id)]; }).map(function (it) {
      var a = TB_ADDONS[String(it.variant_id)]; return { name: a.name, tag: a.tag || "", img: a.img, q: Number(it.qty) || 1 };
    });
  }
  // Add-ons accordion (owner 2026-10-27: "make add-ons also expandable like the oils"), same look as the scents accordion.
  function tbAddonAccordion(item, adds) {
    var k = item.key + ":addons";
    var full = adds.map(function (a) { return a.name + (a.q > 1 ? " ×" + a.q : ""); });
    return '<details class="ap-cart__tb-acc" data-tb-acc="' + escapeHtml(k) + '"' + (tbAccOpen[k] ? " open" : "") + ">" +
      '<summary aria-label="' + escapeHtml(full.join(", ")) + ', show the list"><span class="ap-cart__tb-stack" aria-hidden="true">' +
        adds.map(function (a) { return '<img src="' + escapeHtml(imageUrl(a.img, 96)) + '" alt="" loading="lazy" width="26" height="26">'; }).join("") + "</span>" +
        '<span class="ap-cart__tb-sum">' + escapeHtml(adds.map(function (a) { return a.name.replace(/^Mini /, ""); }).join(" + ")) + "</span>" +
        '<svg class="ap-cart__tb-chev" viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6l4 4 4-4"/></svg></summary>' +
      '<ul class="ap-cart__tb-alist">' + adds.map(function (a) {
        return '<li><img src="' + escapeHtml(imageUrl(a.img, 96)) + '" alt="" loading="lazy" width="26" height="26"><span class="ap-cart__tb-an">' + escapeHtml(a.name) +
          (a.q > 1 ? " <b>×" + a.q + "</b>" : "") + (a.tag ? ' <em class="ap-cart__tb-tag">' + a.tag + "</em>" : "") + "</span></li>";
      }).join("") + "</ul></details>";
  }
  function tierDiffuserLines(item) {
    var props = item.properties || {}, view;
    try { view = JSON.parse(props._tb_view || "null"); } catch (e) { view = null; }
    if (!view || !view.scents || !view.diffuser) return "";
    var qty = item.quantity || 1, mi = tbMinisInfo(item), d = view.diffuser, saveC = tbSaveC(item, view, mi);
    var pill = function (src, name, n, sub, tag) {
      return '<li class="ap-cart__tb-pl">' + (src ? '<img src="' + escapeHtml(imageUrl(src, 96)) + '" alt="" loading="lazy" width="26" height="26">' : '<i aria-hidden="true">' + escapeHtml(String(name || "?").charAt(0)) + "</i>") +
        "<span>" + escapeHtml(name) + "</span>" + (n > 1 ? "<b>×" + n + "</b>" : "") + (sub ? "<small>" + escapeHtml(sub) + "</small>" : "") + (tag ? '<em class="ap-cart__tb-tag">' + tag + "</em>" : "") + "</li>";
    };
    var row = function (label, note, pills, what) {
      return '<div class="ap-cart__tb-row"><p class="ap-cart__tb-k">' + label + (note ? (note.charAt(0) === "<" ? note : "<span>" + note + "</span>") : "") + "</p>" +
        '<ul class="ap-cart__tb-rail" aria-label="' + what + (pills.length > 2 ? ", swipe for more" : "") + '">' + pills.join("") + "</ul></div>";
    };
    var nSc = view.scents.reduce(function (t, sc) { return t + (Number(sc.q) || 1); }, 0);
    var html = '<div class="ap-cart__tb-row"><p class="ap-cart__tb-k">' + nSc + (nSc === 1 ? " scent" : " scents") +
      (view.scents[0] && view.scents[0].ml ? "<span>" + escapeHtml(view.scents[0].ml) + "ml each</span>" : "") + "</p>" + tbScentAccordion(item, view.scents) + "</div>";
    var adds = tbAddons(item);
    var addRow = !adds.length ? "" : adds.length === 1 ? row("Add-ons", "", [pill(adds[0].img, adds[0].name, adds[0].q, "", adds[0].tag)], "Add-ons")
      : '<div class="ap-cart__tb-row"><p class="ap-cart__tb-k">Add-ons</p>' + tbAddonAccordion(item, adds) + "</div>";
    html += row("Diffuser", d.color ? escapeHtml(d.color) : "", [pill(item.image || (item.properties || {})._tb_img, d.name.replace(/^(Luxury|Soft) /, ""), 1, "", money(Math.round((Number(d.price) || 0) * 100)))], "Diffuser");
    html += addRow;
    if (mi.lines.length) {
      var nM = mi.lines.reduce(function (t, m) { return t + Number(m.quantity || 1); }, 0);
      html += row("Minis", nM + (nM === 1 ? " set" : " sets") + " · 30ml",
        mi.lines.map(function (m) { return pill(m.image, String(m.product_title || m.title || "").replace(/\s*[-–—]\s*3-Oil Collection.*$/i, "").replace(/ Scents$/i, ""), Number(m.quantity || 1)); }), "Mini sets");
    }
    var save = "";
    if (saveC > 0) {
      // owner 2026-10-29: no saving line on the bundle card at all ("remove this complete extra you are saving line");
      // the struck total beside the price and the $9.99 diffuser pill already say it
    }
    var out = '<div class="ap-cart__properties ap-cart__tb-lines">' + html + save + "</div>" + tbActions(item);
    // guard: the 10% is for a second box in the same order as its first box
    if (view.second && Number(view.second.extra) > 0 && tbBoxCtx.firsts < 1) out += '<span style="display:block;margin-top:6px;padding:6px 8px;border-radius:8px;background:#fdf3e2;color:#7a4a12;font-weight:700">The second-box saving needs your first bundle in this order.</span>';
    return out;
  }

  // Bundle card actions (owner 2026-10-28): edit this box, add a copy of it, or start a fresh one, all in the builder.
  // Edit replaces this line when the shopper re-adds; Duplicate opens the review step with the same box; New box starts empty.
  var TB_ACT_ICONS = {
    edit: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10.6 2.6l2.8 2.8L6 12.8l-3.4.6.6-3.4z"/><path d="M9.2 4l2.8 2.8"/></svg>',
    copy: '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="5.5" y="5.5" width="8" height="8" rx="1.6"/><path d="M10.5 3.2V3a1.5 1.5 0 0 0-1.5-1.5H4A1.5 1.5 0 0 0 2.5 3v5A1.5 1.5 0 0 0 4 9.5h.3"/></svg>',
    "new": '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 3v10M3 8h10"/></svg>'
  };
  var TB_ACT_SPIN = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 2a6 6 0 1 0 6 6"/></svg>';
  // Duplicate straight in the cart (owner 2026-10-28): the bundle worker makes a new snapshot with its own single-use code
  // from this line's item list (the same request the builder sends), the copy goes in with the same properties and minis
  // sets, and its code joins the cart's other bundle codes. The link (?tb_copy, the builder's review) is the no-JS fallback.
  var TB_API = "https://ap-bundle-discount.damp-leaf-8319.workers.dev/create-bundle-product";
  function tbDuplicate(key, link) {
    if (state.tbDup) return;
    var line = ((state.cart && state.cart.items) || []).filter(function (it) { return it.key === key; })[0];
    var p = (line && line.properties) || {}, its = [], view = tbView(line);
    try { its = JSON.parse(p._bundle_items_json || "[]"); } catch (e) { its = []; }
    var ml = view && view.scents && view.scents[0] && String(view.scents[0].ml || "").replace(/ml$/i, "");
    if (!line || !its.length || !ml) { window.location.href = link; return; }
    var minis = tbMinisOf(key), t0 = Date.now();
    state.tbDup = key; state.tbDupSlow = false; render(state.cart);
    var done = function (ok, info) {
      state.tbDup = null; state.tbDupSlow = false;
      trackCartEvent("bundle_duplicate", Object.assign({ step: ok ? "done" : "failed", seconds: Math.round((Date.now() - t0) / 1000) }, info || {}));
      if (!ok) { render(state.cart); showError("We couldn't duplicate your bundle. Please try again."); }
    };
    var country = (window.Shopify && window.Shopify.country) || "US", data = null;
    fetch(TB_API, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({
      mode: "tier-diffuser", size: ml + "ml", country: country,
      imageUrl: /^https:\/\//.test(String(line.image || "")) ? line.image : "",
      items: its.map(function (it) { return { variant_id: it.variant_id, title: it.title, color: it.color || undefined, price: it.price, qty: it.qty }; })
    }) }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { if (!r.ok || !d.variant_id) throw new Error(String(d.error || "worker " + r.status)); return d; }); })
    .then(function (d) {
      data = d;
      var props = Object.assign({}, p, { _snapshot_product_id: String(d.product_id), _tb_copy: "1", _tb_img: line.image || p._tb_img || undefined });
      if (view && view.second) { var v2 = Object.assign({}, view); delete v2.second; props._tb_view = JSON.stringify(v2); }
      var body = JSON.stringify({ items: [{ id: Number(d.variant_id), quantity: 1, properties: props }].concat(minis.map(function (m) {
        return { id: Number(m.variant_id), quantity: m.quantity, properties: { _tb_addon: "minis", _tb_box: String(d.variant_id), _tb_was: String((m.properties || {})._tb_was || "") } };
      })) });
      // a brand-new bundle can take a while to become addable (422 "Cannot find variant"); retry that for up to 2 minutes
      var waited = 0, tries = 0;
      var attempt = function () {
        return fetch(localePath("/cart/add.js") + "?hide_upez_cart=true", { method: "POST", apCartOwned: true, credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: body })
          .then(function (res) {
            if (res.ok) return res;
            return res.json().catch(function () { return {}; }).then(function (j) {
              var why = String(j.description || "");
              if (res.status !== 422 || !/cannot find variant/i.test(why) || waited >= 120000) throw new Error("add " + res.status + (why ? " " + why.slice(0, 40) : ""));
              tries++; if (tries === 1) { state.tbDupSlow = true; render(state.cart); }
              var pause = Math.min(8000, 1500 * tries); waited += pause;
              return new Promise(function (ok) { setTimeout(ok, pause); }).then(attempt);
            });
          });
      };
      return attempt();
    })
    .then(function () { return api(localePath("/cart.js") + "?t=" + Date.now()); })
    .then(function (cur) {
      if (!data.discount_code) return;
      var keep = (cur.discount_codes || []).map(function (c) { return c.code; }).filter(function (c) { return /^DBUNDLE-/i.test(c) && c !== data.discount_code; });
      return api(localePath("/cart/update.js"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ discount: keep.concat(data.discount_code).join(",") }) })
        .catch(function () { return fetch("/discount/" + encodeURIComponent(data.discount_code) + "?redirect=/cart.js", { credentials: "same-origin" }); });
    })
    .then(function () { return api(localePath("/cart.js") + "?ap_cart=1&t=" + Date.now()); })
    .then(function (cart) {
      var fresh = (cart.items || []).filter(function (it) { return String(it.variant_id) === String(data.variant_id); })[0];
      state.tbFresh = fresh ? fresh.key : null;
      done(true, { oils: its.length, minis: minis.length, value: data.price ? Number(data.price) : undefined });
      state.cart = cart; clearError(); render(cart);
      document.dispatchEvent(new CustomEvent("ap-cart:updated", { bubbles: true, detail: cart }));
      var el = fresh && root.querySelector('[data-ap-cart-line="' + cssEscape(fresh.key) + '"]');
      if (el) el.scrollIntoView({ block: "nearest", behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
      setTimeout(function () { state.tbFresh = null; if (state.cart) render(state.cart); }, 2000);
    })
    .catch(function (e) { done(false, { reason: String((e && e.message) || "error").slice(0, 60) }); fetchCart(); });
  }
  function tbActions(item) {
    var k = encodeURIComponent(item.key), base = localePath("/pages/diffuser-bundle"), busy = state.tbDup === item.key;
    var a = function (act, href, label, aria) {
      var on = busy && act === "copy";
      return '<a class="ap-cart__tb-act' + (on ? " is-busy" : "") + '" href="' + escapeHtml(href) + '" data-ap-tb-act="' + act + '" data-ap-tb-key="' + escapeHtml(item.key) + '" aria-label="' + escapeHtml(aria) + '">' +
        (on ? TB_ACT_SPIN : TB_ACT_ICONS[act]) + "<span>" + (on ? (state.tbDupSlow ? "Preparing…" : "Adding…") : label) + "</span></a>";
    };
    return '<nav class="ap-cart__tb-acts" aria-label="Bundle options"' + (state.tbDup ? ' aria-busy="true"' : "") + ">" +
      a("edit", base + "?tb_edit=" + k + "#step-2", "Edit box", "Edit this bundle") +
      a("copy", base + "?tb_copy=" + k + "#step-2", "Duplicate", "Add another bundle just like this one to your cart") +
      a("new", base + "?tb_new=1#step-2", "New box", "Start a new bundle") + "</nav>";
  }

  // Second bundle invite (owner 2026-10-22), full width under the bundle line: exactly one first box (qty 1), no second box yet.
  var TB_TWO_INVITE_ON = false;  // owner 2026-10-23 (late): second-bundle entry deactivated (set true to show it again)
  function tbTwoInvite(item) {
    if (!TB_TWO_INVITE_ON) return "";
    var props = item.properties || {};
    if (props._bundle_mode !== "tier-diffuser" || (item.quantity || 1) !== 1) return "";
    var view = tbView(item);
    if (!view || view.second || tbBoxCtx.firsts !== 1 || tbBoxCtx.seconds !== 0) return "";
    return '<a class="ap-cart__tb-two" href="' + escapeHtml(localePath('/pages/diffuser-bundle?box=2')) + '" data-ap-tb-two style="grid-column:1 / -1;display:flex;align-items:center;gap:10px;margin-top:10px;padding:9px 10px 9px 12px;border-radius:12px;background:linear-gradient(135deg,#fffaf0,#f5e8cd);box-shadow:inset 0 0 0 1px rgba(167,123,34,.45);color:#13234a;text-decoration:none">' +
      '<svg viewBox="0 0 32 32" aria-hidden="true" style="flex:none;width:22px;height:22px;fill:none;stroke:#a77b22;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round"><rect x="5" y="13" width="22" height="14" rx="2"/><path d="M3.5 9.5h25v4h-25zM16 9.5V27M16 9.5c-2.5-4.5-8-4.5-7-1 .6 1.9 4.2 1.4 7 1zM16 9.5c2.5-4.5 8-4.5 7-1-.6 1.9-4.2 1.4-7 1z"/></svg>' +
      '<span style="display:block;flex:1 1 auto;min-width:0;color:#13234a"><strong style="display:block;font-family:Prata,Georgia,serif;font-weight:400;font-size:14px;line-height:1.25;color:#13234a">Add a 2nd bundle · 10% off</strong>' +
      '<span style="display:block;margin-top:1px;font-size:11.5px;line-height:1.3;color:#5d564e">One to give, one to keep.</span></span>' +
      '<span aria-hidden="true" style="flex:none;display:grid;place-items:center;width:28px;height:28px;border-radius:50%;background:#a77b22;color:#fffdf8;font-weight:800;font-size:15px">→</span></a>';
  }

  function lineProperties(item) {
    var props = item.properties || {};
    if (props._bundle_mode === "tier-diffuser" && props._tb_view) {
      var tb = tierDiffuserLines(item);
      if (tb) return tb;
    }
    var html = Object.keys(props).filter(function (key) {
      return key.charAt(0) !== "_" && !isHiddenCartProperty(key) && props[key] != null && props[key] !== "";
    }).map(function (key) {
      var labelMap = {
        "Amount": text("property_amount", "Amount"),
        "Tier savings": text("property_tier_savings", "Tier savings"),
        "Free gift": text("property_free_gift", "Free gift"),
        "Pairs with": text("property_pairs_with", "Pairs with")
      };
      var value = String(props[key]);
      if (key === "Free gift") {
        var giftMatch = value.match(/^Matching 30 ml (.+) oil \(included, \$9\.99 value\)$/i);
        if (giftMatch) value = formatText("matching_oil_value", "Matching 30 ml __SCENT__ oil (included, $9.99 value)", { SCENT: giftMatch[1] });
      }
      if (key === "Pre-order") return "<strong>Pre-order</strong> · " + escapeHtml(value);
      return escapeHtml(labelMap[key] || key) + ": " + escapeHtml(value);
    }).join("<br>");
    return html ? '<p class="ap-cart__properties">' + html + "</p>" : "";
  }

  function isHiddenCartProperty(key) {
    return /^compatible with\b/i.test(String(key || ""));
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(String(value));
    return String(value).replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  }

  function renderShipping(cart) {
    var shipping = root.querySelector("[data-ap-cart-shipping]");
    if (shipping) shipping.hidden = false;
    var threshold = Number(root.dataset.freeShippingThreshold);
    var total = eligibleCartTotal(cart);
    var remaining = Math.max(0, threshold - total);
    var shippingText = root.querySelector("[data-ap-cart-shipping-text]");
    var bar = root.querySelector("[data-ap-cart-shipping-progress]");
    var priority = root.querySelector("[data-ap-cart-priority]");
    if (shippingText) {
      shippingText.innerHTML = remaining === 0
        ? escapeHtml(text("shipping_unlocked", "Unlocked for this order"))
        : escapeHtml(formatText("shipping_away", "__AMOUNT__ away", { amount: money(remaining) }));
    }
    if (bar) {
      bar.style.width = Math.max(0, Math.min(100, Math.round((total / threshold) * 100))) + "%";
    }
    if (priority) priority.hidden = remaining !== 0;
  }

  function renderCompatibilityWarning(cart) {
    var warning = root.querySelector("[data-ap-cart-compat-warning]");
    if (!warning) return;
    var show = hasWaterlessDiffuserWithRegularOil(cart);
    warning.hidden = !show;
    warning.innerHTML = show ? [
      '<div>',
        '<strong>' + escapeHtml(text("check_compatibility", "Check compatibility")) + '</strong>',
        '<p>' + escapeHtml(text("compatibility_copy", "Swap regular oil for waterless oil before using this diffuser.")) + '</p>',
      '</div>',
      '<a href="' + escapeHtml(localePath("/collections/waterless-fragrance-oils-1")) + '">' + escapeHtml(text("shop_waterless_oils", "Shop waterless oils")) + '</a>'
    ].join("") : "";
  }

// Scent Membership prompt (snippets/ap-cart-membership-prompt.liquid):
  // show for the first one-time waterless fragrance oil in the cart.
  function renderMembershipPrompt(cart) {
    var prompt = root.querySelector("[data-ap-cart-membership]");
    if (!prompt) return;
    var items = (cart && cart.items) || [];
    var oil = null;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item.selling_plan_allocation && item.product_type === "Fragrance Oil" && looksLikeWaterlessOil(item)) { oil = item; break; }
    }
    prompt.hidden = !oil;
    if (!oil) return;
    prompt.setAttribute("href", localePath("/pages/scent-membership-builder") + "?source=cart&product=" + encodeURIComponent(cartItemHandle(oil)) + "&variant=" + encodeURIComponent(oil.variant_id) + "&placement=cart-drawer-membership");
  }

  function updateItemMount(mount, html) {
    if (mount.__apItemHtml === html) return;
    var template = document.createElement("template");
    template.innerHTML = html;
    var lines = {};
    mount.querySelectorAll("[data-ap-cart-line]").forEach(function (line) {
      lines[line.getAttribute("data-ap-cart-line")] = line;
    });
    function sync(current, next) {
      if (current.nodeType === 3 && next.nodeType === 3) {
        if (current.nodeValue !== next.nodeValue) current.nodeValue = next.nodeValue;
        return;
      }
      if (current.nodeType !== 1 || next.nodeType !== 1) return;
      Array.from(current.attributes).forEach(function (attribute) {
        if (!next.hasAttribute(attribute.name)) current.removeAttribute(attribute.name);
      });
      Array.from(next.attributes).forEach(function (attribute) {
        if (current.getAttribute(attribute.name) !== attribute.value) current.setAttribute(attribute.name, attribute.value);
      });
      var cursor = current.firstChild;
      Array.from(next.childNodes).forEach(function (node) {
        var key = node.nodeType === 1 && node.getAttribute("data-ap-cart-line");
        var existing = key && lines[key];
        if (!existing && cursor && cursor.nodeType === node.nodeType && cursor.nodeName === node.nodeName && !(cursor.nodeType === 1 && cursor.hasAttribute("data-ap-cart-line"))) existing = cursor;
        if (!existing) existing = node.cloneNode(false);
        if (existing !== cursor) current.insertBefore(existing, cursor);
        sync(existing, node);
        cursor = existing.nextSibling;
      });
      while (cursor) { var following = cursor.nextSibling; current.removeChild(cursor); cursor = following; }
    }
    var body = root.querySelector(".ap-cart__body");
    var scroll = body ? body.scrollTop : 0;
    var focus = document.activeElement;
    var hadFocus = mount.contains(focus);
    var nextMount = document.createElement("div");
    nextMount.appendChild(template.content);
    Array.from(mount.attributes).forEach(function (attribute) { nextMount.setAttribute(attribute.name, attribute.value); });
    sync(mount, nextMount);
    if (body) body.scrollTop = scroll;
    if (focus && focus.isConnected && root.contains(focus)) focus.focus({ preventScroll: true });
    else if (hadFocus) root.querySelector("button[data-ap-cart-close]").focus({ preventScroll: true });
    mount.__apItemHtml = html;
  }

  // Second box 10% off (owner 2026-10-22): what the Diffuser Bundle lines in this cart look like, for the invite and the guard.
  var tbBoxCtx = { lines: 0, firsts: 0, seconds: 0 };
  function tbView(item) { try { return JSON.parse(((item && item.properties) || {})._tb_view || 'null'); } catch (e) { return null; } }
  function setTbBoxCtx(cart) {
    var ctx = { lines: 0, firsts: 0, seconds: 0 };
    ((cart && cart.items) || []).forEach(function (it) {
      if (!it.properties || it.properties._bundle_mode !== 'tier-diffuser') return;
      var v = tbView(it), q = it.quantity || 0; ctx.lines += q; if (v && v.second) ctx.seconds += q; else ctx.firsts += q;
    });
    tbBoxCtx = ctx;
  }

  function renderItems(cart) {
    setTbBoxCtx(cart);
    var mount = root.querySelector("[data-ap-cart-items]");
    var empty = root.querySelector("[data-ap-cart-empty]");
    var gifts = window.APDDGifts ? eligibleItems(cart).filter(window.APDDGifts.isGift) : [];
    var giftHtml = gifts.map(window.APDDGifts ? window.APDDGifts.giftLineHtml : function () { return ""; }).join("");
    var items = eligibleItems(cart).filter(function (item) { return !(window.APDDGifts && window.APDDGifts.isGift(item)) && !isOrphanGift(item); });
    items = foldTbMinis(items);
    if (state.removedLine && !items.some(function (item) { return item.key === state.removedLine.key; })) {
      items.splice(state.removalIndex, 0, Object.assign({}, state.removedLine, { quantity: 0, __apRemoved: true }));
    }
    var bundleCounts = bundleGroupCounts(cart);
    var accessoryKeys = cartLineAccessoryKeys(items.filter(function (item) { return !item.__apRemoved; }));
    if (!mount) return;
    var bundleScroll = bundleSuggestionScrollState();
    if (empty) empty.hidden = items.length > 0;
    if (!state.bundleGroupsLoaded || !state.cartGroupsLoaded) {
      updateItemMount(mount, giftHtml + items.map(function (item) {
        return renderCartItem(item, bundleCounts, true, accessoryKeys);
      }).join(""));
      restoreBundleSuggestionScroll(bundleScroll);
      if (root.classList.contains("is-open")) loadCartGrouping();
      else warmCartGrouping();
      return;
    }

    var bundleGroups = {};
    var cartGroups = {};
    var otherItems = [];
    var roomMistInserted = false;
    items.forEach(function (item) {
      var bundleKey = item.selling_plan_allocation ? "" : bundleGroupKeyForItem(item);
      var cartKey = cartGroupKeyForItem(item);
      if (bundleKey) {
        if (!bundleGroups[bundleKey]) bundleGroups[bundleKey] = [];
        bundleGroups[bundleKey].push(item);
        return;
      }
      if (cartKey) {
        if (!cartGroups[cartKey]) cartGroups[cartKey] = [];
        cartGroups[cartKey].push(item);
        return;
      }
      otherItems.push(item);
    });

    var html = [];
    var hasCartGroupItems = CART_GROUPS.some(function (group) {
      return cartGroups[group.key] && cartGroups[group.key].length;
    });
    BUNDLE_GROUPS.forEach(function (group) {
      if (!bundleGroups[group.key] || !bundleGroups[group.key].length) return;
      var includeRoomMist = !hasCartGroupItems && !roomMistInserted;
      html.push(renderBundleItemGroup(group, bundleGroups[group.key], bundleCounts[group.key] || 0, includeRoomMist, accessoryKeys));
      if (includeRoomMist) roomMistInserted = true;
    });
    CART_GROUPS.forEach(function (group) {
      if (!cartGroups[group.key] || !cartGroups[group.key].length) return;
      var includeRoomMist = !roomMistInserted;
      html.push(renderCartItemGroup(group, cartGroups[group.key], setupNudgeForGroup(group, bundleGroups), includeRoomMist, accessoryKeys));
      if (includeRoomMist) roomMistInserted = true;
    });
    if (otherItems.length) html.push(renderCartItemGroup({ label: text("other_items", "Other items") }, otherItems, "", !roomMistInserted, accessoryKeys));
    html.push(mergedRecsShell(BUNDLE_GROUPS.filter(function (group) {
      return bundleGroups[group.key] && bundleGroups[group.key].length;
    }).map(function (group) {
      return bundleSuggestionShell(group, bundleCounts[group.key] || 0);
    }).concat(CART_GROUPS.filter(function (group) {
      return group.recommendations && cartGroups[group.key] && cartGroups[group.key].length;
    }).map(function (group) {
      return groupRecommendationShell(group, cartGroups[group.key]);
    })).join("")));
    updateItemMount(mount, giftHtml + html.join(""));
    restoreBundleSuggestionScroll(bundleScroll);
  }

  function cartLineAccessoryKeys(items) {
    var keys = {};
    (items || []).forEach(function (item) {
      if (!item || !item.key) return;
      var groupKey = cartGroupKeyForItem(item);
      if ((groupKey === "humidifying-diffusers" || groupKey === "waterless-diffusers") && !keys[groupKey]) {
        keys[groupKey] = item.key;
      }
      if (!keys.dropper && dropperEligibleForItem(item)) {
        keys.dropper = item.key;
      }
    });
    return keys;
  }

  function bundleSuggestionScrollState() {
    var track = root.querySelector("[data-ap-cart-merged-track]");
    return track ? track.scrollLeft || 0 : 0;
  }

  function restoreBundleSuggestionScroll(scroll) {
    var track = root.querySelector("[data-ap-cart-merged-track]");
    if (track && scroll) track.scrollLeft = scroll;
  }

  // Subscribe switch (owner 2026-11-01): a one-time fragrance-oil line can turn into Subscribe & Save in place
  // (/cart/change.js with selling_plan). Hidden when it would drop the group's multi-buy tier or save nothing.
  var subPlans = {}, subSwitched = {};
  var SUB_FUNNEL = 53179679932597;
  var SUB_PLAN_IDS = [2574778549, 2574811317, 3073441973]; // the oil PDP's plans (sections/ap-waterless-cro-pdp.liquid)
  function subPlansFor(item) {
    var h = item.handle;
    if (!h) return null;
    if (subPlans[h] === undefined) {
      subPlans[h] = null;
      api(localePath("/products/" + h + ".js")).then(function (product) {
        var names = {}, byVariant = {};
        (product.selling_plan_groups || []).forEach(function (g) { (g.selling_plans || []).forEach(function (sp) { names[sp.id] = sp.name; }); });
        (product.variants || []).forEach(function (v) {
          byVariant[v.id] = (v.selling_plan_allocations || []).filter(function (a) {
            return SUB_PLAN_IDS.indexOf(Number(a.selling_plan_id)) !== -1 && names[a.selling_plan_id];
          }).map(function (a) {
            return { id: a.selling_plan_id, name: names[a.selling_plan_id], price: Number(a.price) };
          });
        });
        subPlans[h] = byVariant;
      }).catch(function () {
        subPlans[h] = {};
      }).then(function () {
        if (state.cart) render(state.cart);
      });
    }
    return subPlans[h] ? (subPlans[h][item.variant_id] || []) : null;
  }
  // Owner 2026-11-01: 1 month is the default everywhere (was bottle-matched).
  function subDefaultPlan(item, plans) {
    return plans.filter(function (plan) { return /1 month/i.test(plan.name); })[0] || plans[0];
  }
  function subManaged(item) {
    var props = item.properties || {}, sp = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    return !!sp && !item.__apRemoved && !props._bundle_mode && !props._tb_addon && !props._tb_box && SUB_PLAN_IDS.indexOf(Number(sp.id)) !== -1;
  }
  function subPlanLabel(name) {
    return String(name || "").replace(/^every\s+/i, "");
  }
  function subSwitchRow(item, bundleCounts) {
    var props = item.properties || {};
    if (item.__apRemoved || props._bundle_mode || props._tb_addon || props._tb_box) return "";
    var key = escapeHtml(item.key);
    if (item.selling_plan_allocation) {
      if (!subManaged(item)) return "";
      var switched = !!subSwitched[item.variant_id];
      var current = item.selling_plan_allocation.selling_plan || {};
      var options = (subPlansFor(item) || []).map(function (plan) {
        return '<option value="' + plan.id + '"' + (String(plan.id) === String(current.id) ? " selected" : "") + ">" + escapeHtml(subPlanLabel(plan.name)) + "</option>";
      }).join("");
      return '<div class="ap-cart__subswitch is-on">' +
        '<svg class="ap-cart__subswitch-ok" viewBox="0 0 20 20" aria-hidden="true"><path d="m5 10.5 3 3 7-7"/></svg>' +
        '<label class="ap-cart__subswitch-freq">' + escapeHtml(text("subscribe_every", "Every")) +
          (options ? ' <select data-ap-sub-freq="' + key + '" data-variant="' + item.variant_id + '" aria-label="' + escapeHtml(text("delivery_frequency", "Delivery frequency")) + '">' + options + "</select>" : " " + escapeHtml(subPlanLabel(current.name))) +
        "</label>" +
        '<button type="button" class="ap-cart__subswitch-undo" data-ap-sub-undo="' + key + '" data-variant="' + item.variant_id + '">' + escapeHtml(switched ? text("undo", "Undo") : text("subscribe_one_time", "One-time")) + "</button></div>";
    }
    var group = bundleGroupKeyForItem(item);
    if (!isFragranceOilOfferGroup(group)) return "";
    var plans = subPlansFor(item);
    if (!plans || !plans.length) return "";
    var plan = subDefaultPlan(item, plans), qty = Math.max(1, Number(item.quantity || 1));
    var count = bundleCounts && bundleCounts[group] || 0;
    // ap-cart-sub-net (owner 2026-11-03): a switch that drops the multi-buy tier still shows when the cart comes out
    // ahead; the saving shown is net of the tier discount the other one-time oils in the group would lose.
    var lost = 0, pctNow = count ? bundleTier(count, group).percent : 0, pctAfter = count ? bundleTier(count - qty, group).percent : 0;
    if (pctAfter < pctNow) {
      eligibleItems(state.cart || {}).forEach(function (line) {
        if (line.key === item.key || line.selling_plan_allocation || bundleGroupKeyForItem(line) !== group) return;
        var q = Math.max(1, Number(line.quantity || 1)), unit = Number(line.original_line_price || 0) / q;
        lost += (Math.floor(unit * pctNow / 100) - Math.floor(unit * pctAfter / 100)) * q;
      });
    }
    var now = Number(item.original_line_price || 0) - lineDiscountAmount(item, bundleCounts);
    var save = now - plan.price * qty - lost;
    if (save <= 0) return "";
    var hasFunnel = group === "waterless-oils" && ((state.cart && state.cart.items) || []).some(function (line) { return line.variant_id === SUB_FUNNEL && !line.selling_plan_allocation; });
    return '<button type="button" class="ap-cart__subswitch" data-ap-sub-switch="' + key + '" data-plan="' + plan.id + '" data-variant="' + item.variant_id + '" aria-pressed="false">' +
      '<span class="ap-cart__subswitch-toggle" aria-hidden="true"></span>' +
      // ap-cart-sub-pct (owner 2026-11-03): the plan's percentage, not a dollar amount.
      "<span>" + escapeHtml(text("subscribe_switch", "Join Scent Membership")) + " · <b>" + escapeHtml(formatText("percent_off", "__PERCENT__% off", { percent: Math.round((1 - plan.price * qty / Number(item.original_line_price || 1)) * 100) })) + "</b>" +
      (hasFunnel ? '<span class="ap-cart__subswitch-gift"> · ' + escapeHtml(text("subscribe_switch_funnel", "funnel free")) + "</span>" : "") + "</span></button>";
  }
  function subSetPlan(key, planId, variantId, action) {
    var line = cartLineByKey(key);
    if (!line) return;
    setLineBusy(key, true);
    return api(localePath("/cart/change.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Number(line.quantity || 1), selling_plan: planId ? Number(planId) : null })
    }).then(function (cart) {
      if (planId) subSwitched[variantId] = true;
      else delete subSwitched[variantId];
      state.cart = cart;
      clearError();
      render(cart);
      document.dispatchEvent(new CustomEvent("ap-cart:updated", { bubbles: true, detail: cart }));
      var detail = { variant_id: String(variantId), selling_plan: planId ? String(planId) : "", quantity: Number(line.quantity || 1), product_title: line.product_title || "" };
      trackCartEvent("cart_subscribe_" + action, detail);
      if (typeof window.apTrack === "function") window.apTrack("cart_subscribe_" + action, detail, "cart_subscribe");
    }).catch(function () {
      showError(text("subscribe_switch_error", "We couldn't change this item. Please try again."));
    }).finally(function () {
      setLineBusy(key, false);
    });
  }

  function renderCartItem(item, bundleCounts, showBundleBadge, accessoryKeys) {
    if (item.__apRemoved) return '<div class="ap-cart__removal" data-ap-cart-line="' + escapeHtml(item.key) + '" data-ap-cart-removal><span class="ap-cart__removal-copy" role="status" aria-live="polite"><span class="ap-cart__removal-name" title="' + escapeHtml(item.product_title || item.title) + '">' + escapeHtml(cartItemName(item.product_title || item.title).name) + '</span><span>' + escapeHtml(state.removalRestoring ? text("restoring_item", "Restoring item…") : text("removed", "removed")) + '</span></span><button type="button" data-ap-cart-removal-undo' + (state.removalRestoring ? ' disabled' : '') + '>' + escapeHtml(text("undo", "Undo")) + '</button></div>';
    var productUrl = item.properties && item.properties._bundle_mode === "tower-offer"
      ? "/pages/prime-week-free-tower"
      : item.url || "#";
    var accessory = lineAccessoryInline(item, accessoryKeys);
    var price = tbBundlePriceHtml(item) || linePriceHtml(item, bundleCounts);
    var lineName = cartItemName(item.product_title || item.title);
    var variant = (lineName.sub ? '<p class="ap-cart__variant ap-cart__inspired">' + escapeHtml(lineName.sub) + "</p>" : "")
      + (item.variant_title && item.variant_title !== "Default Title" ? '<p class="ap-cart__variant">' + escapeHtml(item.variant_title) + "</p>" : "");
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && !subManaged(item)
      ? '<p class="ap-cart__plan">' + escapeHtml(item.selling_plan_allocation.selling_plan.name || text("subscription", "Subscription")) + "</p>"
      : "";
    var giftTitle = ((item.line_level_discount_allocations || [])[0] || { discount_application: {} }).discount_application.title || "";
    if (Number(item.final_line_price) === 0 && Number(item.original_line_price) > 0 && /subscri/i.test(giftTitle)) {
      plan += '<p class="ap-cart__plan">' + escapeHtml(text("subscribe_gift", "Scent Membership gift")) + "</p>";
    }
    var bundleBadge = showBundleBadge ? bundleLineBadge(item, bundleCounts) : "";
    return [
      '<article class="ap-cart__item' + (state.tbFresh === item.key ? " is-tb-fresh" : "") + '" data-ap-cart-line="' + escapeHtml(item.key) + '">',
        (item.image || (item.properties || {})._tb_img)
          ? '<img class="ap-cart__image" src="' + escapeHtml(imageUrl(item.image || item.properties._tb_img, 220)) + '" alt="' + escapeHtml(item.product_title || item.title) + '" loading="lazy">'
          : '<div class="ap-cart__image ap-cart__image--empty" aria-hidden="true"><span></span></div>',
        '<div class="ap-cart__item-main ap-cart__item-main--v2">',
          '<a class="ap-cart__item-title" href="' + escapeHtml(localePath(productUrl)) + '" title="' + escapeHtml(lineName.full) + '">' + escapeHtml(lineName.name) + "</a>",
          '<div class="ap-cart__line-meta">',
            variant,
            packItemsHtml(item),
            plan,
            lineProperties(item),
          '</div>',
          '<div class="ap-cart__line-foot">',
            price,
            lineStepper(item),
          '</div>',
          accessory,
          bundleBadge,
        '</div>',
        subSwitchRow(item, bundleCounts),
      '</article>',
      tbTwoInvite(item)
    ].join("");
  }

  // cart-simplify-2026-10-13: quantity stepper. data-qty 0 at quantity 1 keeps the existing remove + Undo flow.
  function packItemsFromTitle(title) {
    var full = String(title || "");
    if (!/set of \d|\d+-pack/i.test(full)) return null;
    var parts = full.split(/\s+[–—-]\s+/);
    if (parts.length < 2) return null;
    var list = parts.slice(1).join(" ").replace(/\s*\(.*$/, "").replace(/\s+Inspired\b.*$/i, "");
    var names = list.split(/\s*[,&|]\s*|\s+and\s+/).map(function (name) { return name.trim(); }).filter(Boolean);
    return names.length > 1 ? names : null;
  }

  function parsePackContent(textValue) {
    var t = String(textValue || "").replace(/\s+/g, " ").trim();
    var each = t.match(/of (.+?) in (?:the|your) selected size/i);
    if (each) return each[1].split(/\s*,\s*|\s+and\s+/).map(function (name) { return name.trim(); }).filter(Boolean);
    var duo = t.match(/^One (.+?) bottle and one (.+?) bottle/i);
    return duo ? [duo[1], duo[2]] : [];
  }

  function packItemsFor(item) {
    var title = item.product_title || item.title || "";
    var fromTitle = packItemsFromTitle(title);
    if (fromTitle) return fromTitle;
    if (!/\d+-Oil Collection|Scent Duo/i.test(title) || !item.handle) return null;
    state.packItems = state.packItems || {};
    if (state.packItems[item.handle] !== undefined) return state.packItems[item.handle];
    state.packItems[item.handle] = null;
    fetch(localePath("/products/" + encodeURIComponent(item.handle)) + "?view=ap-cart-pack", { credentials: "same-origin" })
      .then(function (res) { return res.ok ? res.text() : ""; })
      .then(function (body) {
        var names = [];
        try { names = parsePackContent(JSON.parse(body || "null")); } catch (e) {}
        state.packItems[item.handle] = names.length ? names : null;
        if (names.length && state.cart) render(state.cart);
      })
      .catch(function () {});
    return null;
  }

  function packItemsHtml(item) {
    var names = packItemsFor(item);
    if (!names || !names.length) return "";
    return '<ul class="ap-cart__pack-items" aria-label="' + escapeHtml(text("pack_includes", "Includes")) + '">' + names.map(function (name) {
      return '<li>' + escapeHtml(name) + '</li>';
    }).join("") + '</ul>';
  }

  function lineStepper(item) {
    var quantity = Number(item.quantity || 0);
    // A Diffuser Bundle is one box (its code applies once): no +; remove it, or step down if a line somehow holds more.
    if (item.properties && item.properties._bundle_mode === "tier-diffuser") {
      var bn = cartItemName(item.product_title || item.title).name, one = quantity <= 1;
      return '<div class="ap-cart__stepper ap-cart__stepper--tb" role="group" aria-label="' + escapeHtml(text("quantity", "Quantity")) + '">' +
        '<button type="button" class="ap-cart__step' + (one ? ' ap-cart__step--remove' : '') + '" data-ap-cart-qty="' + escapeHtml(item.key) + '" data-qty="' + (quantity - 1) + '" aria-label="' + escapeHtml(one ? formatText("remove_product", "Remove __PRODUCT__", { product: bn }) : text("decrease_quantity", "Decrease quantity")) + '">' +
        (one ? '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4 6h12"/><path d="M8 6V4.5h4V6"/><path d="m14.8 6-.7 9.5H5.9L5.2 6"/></svg>' : '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 10h10"/></svg>') +
        '</button>' + (one ? '' : '<span>' + quantity + '</span>') + '</div>';
    }
    var name = cartItemName(item.product_title || item.title).name;
    var isLast = quantity <= 1;
    var minusIcon = isLast
      ? '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4 6h12"/><path d="M8 6V4.5h4V6"/><path d="m14.8 6-.7 9.5H5.9L5.2 6"/></svg>'
      : '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 10h10"/></svg>';
    return [
      '<div class="ap-cart__stepper" role="group" aria-label="' + escapeHtml(text("quantity", "Quantity")) + '">',
        '<button type="button" class="ap-cart__step' + (isLast ? ' ap-cart__step--remove' : '') + '" data-ap-cart-qty="' + escapeHtml(item.key) + '" data-qty="' + (quantity - 1) + '" aria-label="' + escapeHtml(isLast ? formatText("remove_product", "Remove __PRODUCT__", { product: name }) : text("decrease_quantity", "Decrease quantity")) + '">' + minusIcon + '</button>',
        '<span>' + quantity + '</span>',
        '<button type="button" class="ap-cart__step" data-ap-cart-qty="' + escapeHtml(item.key) + '" data-qty="' + (quantity + 1) + '" aria-label="' + escapeHtml(text("increase_quantity", "Increase quantity")) + '"><svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 10h10"/><path d="M10 5v10"/></svg></button>',
      '</div>'
    ].join("");
  }

  function lineAccessoryInline(item, accessoryKeys) {
    var groupKey = cartGroupKeyForItem(item);
    if (groupKey === "humidifying-diffusers") return accessoryKeys && accessoryKeys[groupKey] === item.key ? humidifyingCleanerInline() : "";
    if (groupKey === "waterless-diffusers") return accessoryKeys && accessoryKeys[groupKey] === item.key ? waterlessCleanerInline() : "";
    if (!accessoryKeys || accessoryKeys.dropper !== item.key) return "";
    return dropperInline(item);
  }

  function dropperInline(item) {
    if (!dropperEligibleForItem(item)) return "";
    if (state.dropperUnavailable) return "";
    if (state.cart && cartHasProduct(state.cart, state.dropperProduct && state.dropperProduct.id)) return "";
    if (!state.dropperProduct) {
      loadDropperUpsell().then(function () {
        if (state.cart) render(state.cart);
      });
      return "";
    }
    var product = state.dropperProduct;
    var variant = product && product.variants && product.variants[0];
    if (!product || product.available === false || !variant) return "";
    var productUrl = localePath(product.url || ("/products/" + product.handle));
    var image = productImage(product);
    var price = productPrice(product, variant);
    return [
      '<article class="ap-cart__line-cleaner ap-cart__line-cleaner--dropper" data-ap-cart-line-cleaner data-ap-cart-rec="fragrance-dropper" data-ap-cart-rec-product="' + escapeHtml(product.id) + '">',
        image ? '<a class="ap-cart__line-cleaner-media" href="' + escapeHtml(productUrl) + '" aria-label="' + escapeHtml(formatText("view_product", "View __PRODUCT__", { product: product.title })) + '"><img src="' + escapeHtml(imageUrl(image, 120)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></a>' : "",
        '<div class="ap-cart__line-cleaner-main">',
          '<a class="ap-cart__line-cleaner-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(text("dropper", "Dropper")) + (price ? ' · ' + escapeHtml(price) : '') + '</a>',
          '<p>' + escapeHtml(text("dropper_copy", "Precise drops · no drip, no waste")) + '</p>',
        '</div>',
        '<button type="button" class="ap-cart__line-cleaner-add" data-ap-cart-add-rec="fragrance-dropper" data-ap-cart-add-variant="' + escapeHtml(variant.id) + '" aria-label="' + escapeHtml(formatText("add_product_to_cart", "Add __PRODUCT__ to cart", { product: product.title })) + '"><svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 3.5v9M3.5 8h9"/></svg><span>' + escapeHtml(text("add", "Add")) + '</span></button>',
      '</article>'
    ].join("");
  }

  function dropperEligibleForItem(item) {
    if (!item || !item.product_id) return false;
    if (state.dropperProduct && String(item.product_id) === String(state.dropperProduct.id)) return false;
    if (!state.dropperEligibleLoaded) {
      loadDropperEligibleProducts().then(function () {
        if (state.cart) render(state.cart);
      });
      return false;
    }
    return Boolean(state.dropperEligibleProducts[String(item.product_id)]);
  }

  function humidifyingCleanerInline() {
    if (state.humidifyingCleanerUnavailable) return "";
    if (state.cart && cartHasProduct(state.cart, state.humidifyingCleanerProduct && state.humidifyingCleanerProduct.id)) return "";
    if (!state.humidifyingCleanerProduct) {
      loadHumidifyingCleanerUpsell().then(function () {
        if (state.cart) render(state.cart);
      });
      return "";
    }
    var product = state.humidifyingCleanerProduct;
    var variant = product && product.variants && product.variants[0];
    if (!product || product.available === false || !variant) return "";
    var productUrl = localePath(product.url || ("/products/" + product.handle));
    var image = productImage(product);
    var price = productPrice(product, variant);
    return [
      '<article class="ap-cart__line-cleaner" data-ap-cart-line-cleaner data-ap-cart-rec="humidifying-cleaner" data-ap-cart-rec-product="' + escapeHtml(product.id) + '">',
        image ? '<a class="ap-cart__line-cleaner-media" href="' + escapeHtml(productUrl) + '" aria-label="' + escapeHtml(formatText("view_product", "View __PRODUCT__", { product: product.title })) + '"><img src="' + escapeHtml(imageUrl(image, 120)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></a>' : "",
        '<div class="ap-cart__line-cleaner-main">',
          '<a class="ap-cart__line-cleaner-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(text("diffuser_cleaner", "Diffuser cleaner")) + (price ? ' · ' + escapeHtml(price) : '') + '</a>',
          '<p>' + escapeHtml(text("humidifying_cleaner_copy", "Removes scale & residue")) + '</p>',
        '</div>',
        '<button type="button" class="ap-cart__line-cleaner-add" data-ap-cart-add-rec="humidifying-cleaner" data-ap-cart-add-variant="' + escapeHtml(variant.id) + '" aria-label="' + escapeHtml(formatText("add_product_to_cart", "Add __PRODUCT__ to cart", { product: product.title })) + '"><svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 3.5v9M3.5 8h9"/></svg><span>' + escapeHtml(text("add", "Add")) + '</span></button>',
      '</article>'
    ].join("");
  }

  function waterlessCleanerInline() {
    if (state.waterlessCleanerUnavailable) return "";
    if (state.cart && cartHasProduct(state.cart, state.waterlessCleanerProduct && state.waterlessCleanerProduct.id)) return "";
    if (!state.waterlessCleanerProduct) {
      loadWaterlessCleanerUpsell().then(function () {
        if (state.cart) render(state.cart);
      });
      return "";
    }
    var product = state.waterlessCleanerProduct;
    var variant = product && product.variants && product.variants[0];
    if (!product || product.available === false || !variant) return "";
    var productUrl = localePath(product.url || ("/products/" + product.handle));
    var image = productImage(product);
    var price = productPrice(product, variant);
    return [
      '<article class="ap-cart__line-cleaner" data-ap-cart-line-cleaner data-ap-cart-rec="waterless-cleaner" data-ap-cart-rec-product="' + escapeHtml(product.id) + '">',
        image ? '<a class="ap-cart__line-cleaner-media" href="' + escapeHtml(productUrl) + '" aria-label="' + escapeHtml(formatText("view_product", "View __PRODUCT__", { product: product.title })) + '"><img src="' + escapeHtml(imageUrl(image, 120)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></a>' : "",
        '<div class="ap-cart__line-cleaner-main">',
          '<a class="ap-cart__line-cleaner-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(text("diffuser_cleaner", "Diffuser cleaner")) + (price ? ' · ' + escapeHtml(price) : '') + '</a>',
          '<p>' + escapeHtml(text("waterless_cleaner_copy", "Clears oil buildup")) + '</p>',
        '</div>',
        '<button type="button" class="ap-cart__line-cleaner-add" data-ap-cart-add-rec="waterless-cleaner" data-ap-cart-add-variant="' + escapeHtml(variant.id) + '" aria-label="' + escapeHtml(formatText("add_product_to_cart", "Add __PRODUCT__ to cart", { product: product.title })) + '"><svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 3.5v9M3.5 8h9"/></svg><span>' + escapeHtml(text("add", "Add")) + '</span></button>',
      '</article>'
    ].join("");
  }

  function loadHumidifyingCleanerUpsell() {
    if (state.humidifyingCleanerProduct || state.humidifyingCleanerUnavailable) return Promise.resolve(state.humidifyingCleanerProduct);
    if (state.humidifyingCleanerLoading) return state.humidifyingCleanerLoading;
    state.humidifyingCleanerLoading = fetch(localePath("/products/" + encodeURIComponent(HUMIDIFYING_CLEANER_UPSELL_HANDLE) + ".js"), {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).then(function (product) {
      if (!product || product.available === false || !product.variants || !product.variants.length) {
        state.humidifyingCleanerUnavailable = true;
        return null;
      }
      state.humidifyingCleanerProduct = product;
      return product;
    }).catch(function () {
      state.humidifyingCleanerUnavailable = true;
      return null;
    }).finally(function () {
      state.humidifyingCleanerLoading = null;
    });
    return state.humidifyingCleanerLoading;
  }

  function loadWaterlessCleanerUpsell() {
    if (state.waterlessCleanerProduct || state.waterlessCleanerUnavailable) return Promise.resolve(state.waterlessCleanerProduct);
    if (state.waterlessCleanerLoading) return state.waterlessCleanerLoading;
    state.waterlessCleanerLoading = fetch(localePath("/products/" + encodeURIComponent(WATERLESS_CLEANER_UPSELL_HANDLE) + ".js"), {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("Waterless cleaner product unavailable");
      return response.json();
    }).then(function (product) {
      if (!product || !product.available) {
        state.waterlessCleanerUnavailable = true;
        return null;
      }
      state.waterlessCleanerProduct = product;
      return product;
    }).catch(function () {
      state.waterlessCleanerUnavailable = true;
      return null;
    }).finally(function () {
      state.waterlessCleanerLoading = null;
    });
    return state.waterlessCleanerLoading;
  }

  function loadDropperUpsell() {
    if (state.dropperProduct || state.dropperUnavailable) return Promise.resolve(state.dropperProduct);
    if (state.dropperLoading) return state.dropperLoading;
    state.dropperLoading = fetch(localePath("/products/" + encodeURIComponent(DROPPER_UPSELL_HANDLE) + ".js"), {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("Dropper product unavailable");
      return response.json();
    }).then(function (product) {
      if (!product || !product.available || !product.variants || !product.variants.length) {
        state.dropperUnavailable = true;
        return null;
      }
      state.dropperProduct = product;
      return product;
    }).catch(function () {
      state.dropperUnavailable = true;
      return null;
    }).finally(function () {
      state.dropperLoading = null;
    });
    return state.dropperLoading;
  }

  function moneyCents(cents) {
    var formatted = money(cents);
    return /\.\d{2}$/.test(formatted) ? formatted : formatted.replace(/(\d)$/, "$1.00");
  }

  function linePriceHtml(item, bundleCounts) {
    var original = Number(item.original_line_price || 0);
    var final = Number(item.final_line_price || 0);
    var discount = lineDiscountAmount(item, bundleCounts);
    var displayFinal = discount > 0 ? Math.max(0, original - discount) : (item.final_line_price != null ? final : original);
    var planCompare = item.selling_plan_allocation ? Number(item.selling_plan_allocation.compare_at_price || 0) * Math.max(1, Number(item.quantity || 1)) : 0;
    var strike = discount > 0 && original > displayFinal ? original : 0;
    if (planCompare > displayFinal && planCompare > strike) strike = planCompare;
    var compare = strike ? '<span class="ap-cart__compare">' + moneyCents(strike) + "</span>" : "";
    // ap-cart-percent-off (owner 2026-11-02): every struck price gets its percentage, subscriptions included.
    var discountLabel = strike > displayFinal && displayFinal > 0 ? lineDiscountLabel(item, strike - displayFinal, strike) : "";
    return [
      '<div class="ap-cart__price-row">',
        '<span class="ap-cart__price">' + (displayFinal === 0 && discount > 0 ? escapeHtml(text("free", "Free")) : moneyCents(displayFinal)) + "</span>",
        compare,
        discountLabel,
      '</div>'
    ].join("");
  }

  function lineDiscountAmount(item, bundleCounts) {
    var actual = actualLineDiscountAmount(item);
    return actual > 0 ? actual : estimatedBundleDiscountAmount(item, bundleCounts);
  }

  function actualLineDiscountAmount(item) {
    return Math.max(0, Number(item.original_line_price || 0) - Number(item.final_line_price || 0));
  }

  function estimatedBundleDiscountAmount(item, bundleCounts) {
    if (!bundleCounts || item.selling_plan_allocation) return 0;
    var groupKey = bundleGroupKeyForItem(item);
    if (!groupKey) return 0;
    var tier = bundleTier(bundleCounts[groupKey] || 0, groupKey);
    if (!tier.percent) return 0;
    var quantity = Math.max(1, Number(item.quantity || 1));
    var unit = Number(item.original_line_price || 0) / quantity;
    return Math.floor(unit * tier.percent / 100) * quantity;
  }

  function lineDiscountLabel(item, discount, original) {
    var percent = original > 0 ? Math.round((discount / original) * 100) : 0;
    var label = percent >= 1
      ? formatText("percent_off", "__PERCENT__% off", { percent: percent })
      : formatText("save_amount", "Save __AMOUNT__", { amount: money(discount) });
    return '<span class="ap-cart__saving">' + escapeHtml(label) + "</span>";
  }

  function renderBundleItemGroup(group, items, count, includeRoomMist, accessoryKeys) {
    var counts = {};
    counts[group.key] = count;
    return [
      '<section class="ap-cart__bundle-group">',
        bundleGroupHeader(group, count),
        items.map(function (item) {
          return renderCartItem(item, counts, false, accessoryKeys);
        }).join(""),
        includeRoomMist ? roomMistUpsellShell() : "",
      '</section>'
    ].join("");
  }

  function bundleSuggestionShell(group, count) {
    if (!group || !group.handle || count >= 5) return "";
    var cachedHtml = state.bundleSuggestionHtml[group.key] || "";
    var hidden = cachedHtml ? "" : " hidden";
    return [
      '<div class="ap-cart__recs-seg" data-ap-cart-bundle-suggestions="' + escapeHtml(group.key) + '" data-ap-cart-bundle-handle="' + escapeHtml(group.handle) + '"' + hidden + '>',
        '<div class="ap-cart__recs-seg-track" data-ap-cart-bundle-suggestions-track="' + escapeHtml(group.key) + '">' + cachedHtml + '</div>',
      '</div>'
    ].join("");
  }

  // cart-simplify-2026-10-13: bundle suggestions and curated pairings share one carousel below the items.
  function mergedRecsShell(segments) {
    if (!segments) return "";
    return [
      '<section class="ap-cart__recs ap-cart__recs--merged" data-ap-cart-merged-recs>',
        '<div class="ap-cart__recs-heading">',
          '<div><span class="ap-cart__recs-kicker">' + escapeHtml(text("complete_your_order", "Complete your order")) + '</span></div>',
          '<div class="ap-cart__recs-nav" aria-label="' + escapeHtml(text("recommendation_navigation", "Recommendation navigation")) + '">',
            '<button type="button" data-ap-cart-merged-prev aria-label="' + escapeHtml(text("previous_recommendations", "Previous recommendations")) + '">',
              '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
            '</button>',
            '<button type="button" data-ap-cart-merged-next aria-label="' + escapeHtml(text("next_recommendations", "Next recommendations")) + '">',
              '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
            '</button>',
          '</div>',
        '</div>',
        '<div class="ap-cart__recs-track" data-ap-cart-merged-track>' + segments + '</div>',
      '</section>'
    ].join("");
  }

  function renderCartItemGroup(group, items, setupNudge, includeRoomMist, accessoryKeys) {
    return [
      '<section class="ap-cart__item-group">',
        '<div class="ap-cart__item-group-head">',
          '<span>' + escapeHtml(group.label || text("items", "Items")) + '</span>',
          '<strong>' + itemGroupCount(items) + '</strong>',
        '</div>',
        items.map(function (item) {
          return renderCartItem(item, {}, false, accessoryKeys);
        }).join(""),
        setupNudge || "",
        includeRoomMist ? roomMistUpsellShell() : "",
      '</section>'
    ].join("");
  }

  function roomMistUpsellShell() {
    return "";
  }

  function cartHasBundleKey(keys) {
    return eligibleItems(state.cart || { items: [] }).some(function (item) {
      return keys.indexOf(bundleGroupKeyForItem(item)) !== -1;
    });
  }

  function setupNudgeForGroup(group, bundleGroups) {
    var key = group && group.key;
    if (key === "humidifying-diffusers" && !hasAnyBundleGroup(bundleGroups, ["regular-hotel", "regular-perfume", "regular-nature"]) && !cartHasBundleKey(["regular-hotel", "regular-perfume", "regular-nature"])) {
      return setupNudgeHtml(text("complete_setup", "Complete your setup"), text("humidifying_setup", "Add a compatible humidifying oil for your diffuser."));
    }
    if (key === "waterless-diffusers" && !hasAnyBundleGroup(bundleGroups, ["waterless-oils"]) && !cartHasBundleKey(["waterless-oils"])) {
      return setupNudgeHtml(text("complete_setup", "Complete your setup"), text("waterless_setup", "Add a waterless fragrance oil for your cold-air diffuser."));
    }
    return "";
  }

  function hasAnyBundleGroup(bundleGroups, keys) {
    return keys.some(function (key) {
      return bundleGroups[key] && bundleGroups[key].length;
    });
  }

  function setupNudgeHtml(title, copy) {
    return [
      '<div class="ap-cart__setup-nudge">',
        '<span>' + escapeHtml(title) + '</span>',
        '<p>' + escapeHtml(copy) + '</p>',
      '</div>'
    ].join("");
  }

  function groupRecommendationShell(group, items) {
    var source = (items || []).find(function (item) {
      return item && item.product_id;
    });
    if (!source) return "";
    return [
      '<div class="ap-cart__recs-seg" data-ap-cart-group-recs="' + escapeHtml(group.key) + '" data-ap-cart-group-recs-source="' + escapeHtml(source.product_id) + '" hidden>',
        '<div class="ap-cart__recs-seg-track" data-ap-cart-group-recs-track="' + escapeHtml(group.key) + '"></div>',
      '</div>'
    ].join("");
  }

  function itemGroupCount(items) {
    return (items || []).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  // cart-simplify-2026-10-13: compact tier strip. One line says what to do; pills spell out each tier and fill when reached.
  function bundleGroupHeader(group, count) {
    var tiers = isFragranceOilOfferGroup(group)
      ? [{ at: 3, percent: 5 }, { at: 5, percent: 10 }, { at: 7, percent: 15 }]
      : [{ at: 3, percent: 15 }, { at: 5, percent: 20 }];
    var nextFound = false;
    return [
      '<div class="ap-cart__bundle-group-head ap-cart__tiers' + (count >= tiers[tiers.length - 1].at ? ' is-complete' : '') + '">',
        '<p class="ap-cart__tiers-copy" aria-live="polite"><svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10.6 2.8H16a1.2 1.2 0 0 1 1.2 1.2v5.4a1.2 1.2 0 0 1-.35.85l-6.7 6.7a1.2 1.2 0 0 1-1.7 0L3.05 11.6a1.2 1.2 0 0 1 0-1.7l6.7-6.7a1.2 1.2 0 0 1 .85-.4Z"/><circle cx="13.6" cy="6.4" r="1.3"/></svg><span>' + bundleGroupProgressCopy(group, count) + '</span></p>',
        '<ul class="ap-cart__tiers-pills" aria-label="' + escapeHtml(text("bundle_tiers", "Bundle discounts")) + '">',
          tiers.map(function (tier) {
            var state = count >= tier.at ? "is-reached" : (!nextFound ? "is-next" : "");
            if (state === "is-next") nextFound = true;
            return '<li class="ap-cart__tiers-pill ' + state + '">'
              + (state === "is-reached" ? '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="m3.5 8.4 2.9 2.9 6.1-6.6"/></svg>' : "")
              + escapeHtml(formatText("bundle_tier_pill", "Buy __COUNT__ · __PERCENT__% off", { count: tier.at, percent: tier.percent })) + '</li>';
          }).join(""),
        '</ul>',
      '</div>'
    ].join("");
  }

  function collectionProductsUrl(handle) {
    return localePath("/collections/" + encodeURIComponent(handle) + "/products.json") + "?limit=250";
  }

  function readBundleGroupCache() {
    try {
      var cached = JSON.parse(window.localStorage.getItem(BUNDLE_CACHE_KEY) || "null");
      if (!cached || !cached.savedAt || Date.now() - cached.savedAt > 86400000 || !cached.groups || !Object.keys(cached.groups).length) return false;
      state.bundleProductGroups = cached.groups;
      state.bundleGroupsLoaded = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function writeBundleGroupCache() {
    try {
      window.localStorage.setItem(BUNDLE_CACHE_KEY, JSON.stringify({
        savedAt: Date.now(),
        groups: state.bundleProductGroups
      }));
    } catch (e) {}
  }

  function readCartGroupCache() {
    try {
      var cached = JSON.parse(window.localStorage.getItem(CART_GROUP_CACHE_KEY) || "null");
      if (!cached || !cached.savedAt || Date.now() - cached.savedAt > 86400000 || !cached.groups || !Object.keys(cached.groups).length) return false;
      state.cartProductGroups = cached.groups;
      state.cartGroupsLoaded = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function writeCartGroupCache() {
    try {
      window.localStorage.setItem(CART_GROUP_CACHE_KEY, JSON.stringify({
        savedAt: Date.now(),
        groups: state.cartProductGroups
      }));
    } catch (e) {}
  }

  function readDropperEligibleCache() {
    try {
      var cached = JSON.parse(window.localStorage.getItem(DROPPER_ELIGIBLE_CACHE_KEY) || "null");
      if (!cached || !cached.savedAt || Date.now() - cached.savedAt > 86400000 || !cached.products || !Object.keys(cached.products).length) return false;
      state.dropperEligibleProducts = cached.products;
      state.dropperEligibleLoaded = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function writeDropperEligibleCache() {
    try {
      window.localStorage.setItem(DROPPER_ELIGIBLE_CACHE_KEY, JSON.stringify({
        savedAt: Date.now(),
        products: state.dropperEligibleProducts
      }));
    } catch (e) {}
  }

  function loadDropperEligibleProducts() {
    if (state.dropperEligibleLoaded) return Promise.resolve(state.dropperEligibleProducts);
    if (readDropperEligibleCache()) return Promise.resolve(state.dropperEligibleProducts);
    if (state.dropperEligibleLoading) return state.dropperEligibleLoading;
    state.dropperEligibleLoading = Promise.all(DROPPER_ELIGIBLE_COLLECTIONS.map(function (group) {
      return fetch(collectionProductsUrl(group.handle), {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        products.forEach(function (product) {
          if (!product || !product.id) return;
          state.dropperEligibleProducts[String(product.id)] = group.key;
        });
      }).catch(function () {});
    })).then(function () {
      state.dropperEligibleLoaded = true;
      state.dropperEligibleLoading = null;
      if (Object.keys(state.dropperEligibleProducts).length) writeDropperEligibleCache();
      if (state.cart) render(state.cart);
      return state.dropperEligibleProducts;
    });
    return state.dropperEligibleLoading;
  }

  function loadCartGroups() {
    if (state.cartGroupsLoaded) return Promise.resolve(state.cartProductGroups);
    if (readCartGroupCache()) return Promise.resolve(state.cartProductGroups);
    if (state.cartGroupsLoading) return state.cartGroupsLoading;
    state.cartGroupsLoading = Promise.all(CART_GROUPS.map(function (group) {
      return fetch(collectionProductsUrl(group.handle), {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        products.forEach(function (product) {
          if (!product || !product.id) return;
          var id = String(product.id);
          if (!state.cartProductGroups[id]) state.cartProductGroups[id] = group.key;
        });
      }).catch(function () {});
    })).then(function () {
      state.cartGroupsLoaded = true;
      state.cartGroupsLoading = null;
      if (Object.keys(state.cartProductGroups).length) writeCartGroupCache();
      if (state.cart) render(state.cart);
      return state.cartProductGroups;
    });
    return state.cartGroupsLoading;
  }

  function loadCartGrouping() {
    return Promise.all([loadBundleGroups(), loadCartGroups(), loadDropperEligibleProducts()]);
  }

  function warmCartGrouping() {
    if (!state.cart || !eligibleItems(state.cart).length) return;
    if (state.bundleGroupsLoaded && state.cartGroupsLoaded && state.dropperEligibleLoaded) return;
    if ((state.bundleGroupsLoaded || state.bundleGroupsLoading) && (state.cartGroupsLoaded || state.cartGroupsLoading) && (state.dropperEligibleLoaded || state.dropperEligibleLoading)) return;
    window.setTimeout(loadCartGrouping, 500);
  }

  function loadBundleGroups() {
    if (state.bundleGroupsLoaded) return Promise.resolve(state.bundleProductGroups);
    if (readBundleGroupCache()) return Promise.resolve(state.bundleProductGroups);
    if (state.bundleGroupsLoading) return state.bundleGroupsLoading;
    state.bundleGroupsLoading = Promise.all(BUNDLE_GROUPS.map(function (group) {
      return fetch(collectionProductsUrl(group.handle), {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        products.forEach(function (product) {
          if (!product || !product.id) return;
          var id = String(product.id);
          if (!state.bundleProductGroups[id]) state.bundleProductGroups[id] = group.key;
        });
      }).catch(function () {});
    })).then(function () {
      state.bundleGroupsLoaded = true;
      state.bundleGroupsLoading = null;
      if (Object.keys(state.bundleProductGroups).length) writeBundleGroupCache();
      if (state.cart) render(state.cart);
      return state.bundleProductGroups;
    });
    return state.bundleGroupsLoading;
  }

  function bundleGroupByKey(key) {
    return BUNDLE_GROUPS.find(function (group) {
      return group.key === key;
    }) || null;
  }

  function bundleGroupKeyForItem(item) {
    if (!item) return "";
    if (!item.product_id) return "";
    return state.bundleProductGroups[String(item.product_id)] || "";
  }

  function cartGroupKeyForItem(item) {
    if (!item) return "";
    if (!item.product_id) return "";
    return state.cartProductGroups[String(item.product_id)] || "";
  }

  function hasWaterlessDiffuserWithRegularOil(cart) {
    if (!state.bundleGroupsLoaded || !state.cartGroupsLoaded) return false;
    var hasWaterlessDiffuser = false;
    var hasRegularOil = false;
    eligibleItems(cart).forEach(function (item) {
      if (cartGroupKeyForItem(item) === "waterless-diffusers") hasWaterlessDiffuser = true;
      if (["regular-hotel", "regular-perfume", "regular-nature"].indexOf(bundleGroupKeyForItem(item)) !== -1) hasRegularOil = true;
    });
    return hasWaterlessDiffuser && hasRegularOil;
  }

  function bundleGroupCounts(cart) {
    var counts = {};
    eligibleItems(cart).forEach(function (item) {
      if (item.selling_plan_allocation) return;
      var groupKey = bundleGroupKeyForItem(item);
      if (!groupKey) return;
      counts[groupKey] = (counts[groupKey] || 0) + Number(item.quantity || 0);
    });
    return counts;
  }

  function isFragranceOilOfferGroup(group) {
    var key = typeof group === "string" ? group : group && group.key;
    return FRAGRANCE_OIL_OFFER_GROUPS.indexOf(key) !== -1;
  }

  function bundleTier(count, group) {
    if (isFragranceOilOfferGroup(group)) {
      if (count >= 7) return { percent: 15, next: 0, target: 7 };
      if (count >= 5) return { percent: 10, next: 7 - count, target: 7 };
      if (count >= 3) return { percent: 5, next: 5 - count, target: 5 };
      return { percent: 0, next: 3 - count, target: 3 };
    }
    if (count >= 5) return { percent: 20, next: 0, target: 5 };
    if (count >= 3) return { percent: 15, next: 5 - count, target: 5 };
    return { percent: 0, next: 3 - count, target: 3 };
  }

  function bundleProgressCopy(count, group) {
    var tier = bundleTier(count, group);
    if (isFragranceOilOfferGroup(group)) {
      if (tier.next === 0) return formatText("bundle_progress", "__PERCENT__% unlocked", { percent: tier.percent });
      if (tier.percent > 0) return formatText("bundle_progress_next", "__PERCENT__% unlocked · __COUNT__ to __NEXT_PERCENT__%", { percent: tier.percent, count: tier.next, next_percent: tier.percent + 5 });
      return formatText("bundle_progress_start", "__COUNT__ to __PERCENT__%", { count: tier.next, percent: 5 });
    }
    if (tier.percent === 20) return formatText("bundle_progress", "__PERCENT__% unlocked", { percent: 20 });
    if (tier.percent === 15) {
      return formatText("bundle_progress_next", "__PERCENT__% unlocked · __COUNT__ to __NEXT_PERCENT__%", { percent: 15, count: tier.next, next_percent: 20 });
    }
    return formatText("bundle_progress_start", "__COUNT__ to __PERCENT__%", { count: tier.next, percent: 15 });
  }

  function bundleGroupProgressCopy(group, count) {
    var tier = bundleTier(count, group);
    var noun = bundleGroupNoun(group);
    var next = tier.percent === 0 ? (isFragranceOilOfferGroup(group) ? 5 : 15) : tier.percent + 5;
    var em = function (value) { return "<strong>" + escapeHtml(value) + "</strong>"; };
    if (tier.next === 0) return em(formatText("bundle_off_applied", "__PERCENT__% off", { percent: tier.percent })) + " " + escapeHtml(formatText("bundle_best_price", "unlocked · best bundle price", {}));
    if (tier.next === 1) noun = noun.replace(/(scent|oil|bracelet)s$/i, "$1");
    if (tier.percent > 0) return em(formatText("bundle_off_applied", "__PERCENT__% off", { percent: tier.percent })) + " " + escapeHtml(formatText("bundle_applied_next", "unlocked · Add __COUNT__ more __ITEM__ for __NEXT_PERCENT__%", { count: tier.next, item: noun.split(" ").pop(), next_percent: next }));
    return escapeHtml(formatText("bundle_add_more", "Add __COUNT__ more __GROUP__ for", { count: tier.next, group: noun })) + " " + em(formatText("bundle_off_applied", "__PERCENT__% off", { percent: next }));
  }

  function bundleGroupNoun(group) {
    var key = group && group.key;
    if (key === "regular-hotel") return text("hotel_scents", "hotel scents");
    if (key === "regular-perfume") return text("perfume_scents", "perfume scents");
    if (key === "regular-nature") return text("nature_scents", "nature scents");
    if (key === "waterless-oils") return text("waterless_scents", "waterless scents");
    if (key === "incense-sticks") return text("incense", "incense");
    if (key === "perfume-body-oils") return text("body_oils", "body oils").toLowerCase();
    if (key === "bracelets") return text("bracelets", "bracelets").toLowerCase();
    return String(group && group.label || text("scents", "scents")).toLowerCase();
  }

  function bundleLineBadge(item, counts) {
    if (!item || item.selling_plan_allocation) return "";
    var groupKey = bundleGroupKeyForItem(item);
    var group = bundleGroupByKey(groupKey);
    if (!group) return "";
    var count = counts[groupKey] || 0;
    var tier = bundleTier(count, group);
    var label = tier.percent
      ? formatText("bundle_discount", "__PERCENT__% bundle discount", { percent: tier.percent })
      : formatText("bundle_offer", "Bundle offer · __PROGRESS__", { progress: bundleProgressCopy(count, group) });
    return [
      '<p class="ap-cart__bundle-line">',
        '<span>' + escapeHtml(compactBundleLabel(group)) + '</span>',
        '<strong>' + escapeHtml(label) + '</strong>',
      '</p>'
    ].join("");
  }

  function compactBundleLabel(group) {
    var key = group && group.key;
    if (key === "regular-hotel") return text("hotel_bundle", "Hotel Bundle");
    if (key === "regular-perfume") return text("perfume_bundle", "Perfume Bundle");
    if (key === "regular-nature") return text("nature_bundle", "Nature Bundle");
    if (key === "waterless-oils") return text("waterless_bundle", "Waterless Bundle");
    if (key === "incense-sticks") return text("incense_bundle", "Incense Bundle");
    if (key === "perfume-body-oils") return text("body_oil_bundle", "Body Oil Bundle");
    if (key === "bracelets") return text("bracelets_bundle", "Bracelets Bundle");
    return String(group && group.label || "")
      .replace(/\s+fragrance oils?$/i, "")
      .replace(/\s+oils?$/i, "")
      .replace(/\s+sticks?$/i, "")
      .trim() + " Bundle";
  }

  function renderBundleProgress(cart) {
    var mount = root.querySelector("[data-ap-cart-bundle-progress]");
    if (!mount) return;
    mount.hidden = true;
    mount.innerHTML = "";
    if (!state.bundleGroupsLoaded) {
      if (root.classList.contains("is-open")) loadBundleGroups();
      else warmBundleGroups();
    }
  }

  function isCanadaCart() {
    return String(root.dataset.localizationCountry || "").toUpperCase() === "CA";
  }

  function renderProtection(cart) {
    var variantId = root.dataset.protectionVariantId;
    var row = root.querySelector("[data-ap-cart-protection]");
    var price = root.querySelector("[data-ap-cart-protection-price]");
    var without = root.querySelector("[data-ap-cart-checkout-without]");
    var checkoutRow = root.querySelector(".ap-cart__checkout-row");
    var checkoutLabel = root.querySelector("[data-ap-cart-checkout-label]");
    var importDuty = root.querySelector("[data-ap-cart-import-duty]");
    if (!row) return;
    var itemCount = eligibleItems(cart).length;
    var canadaCart = isCanadaCart();
    var enabled = !canadaCart && Boolean(variantId) && itemCount > 0;
    row.hidden = !enabled;
    if (checkoutRow) checkoutRow.hidden = canadaCart ? itemCount <= 0 : !enabled;
    if (without) without.hidden = !enabled;
    if (checkoutLabel) checkoutLabel.textContent = canadaCart ? text("checkout", "Checkout") : text("checkout_plus", "Checkout+");
    if (importDuty) importDuty.hidden = !(canadaCart && itemCount > 0);
    if (price) price.textContent = root.dataset.protectionPrice ? "+" + money(root.dataset.protectionPrice) : "";
  }

  function priorityPlusItem(cart) {
    var variantId = root.dataset.priorityPlusVariantId;
    if (!variantId || !cart) return null;
    return (cart.items || []).find(function (item) {
      return String(item.variant_id) === String(variantId);
    }) || null;
  }

  function priorityPlusSelected(cart) {
    return !isCanadaCart() && Boolean(root.dataset.priorityPlusVariantId) && eligibleItems(cart).length > 0 && state.priorityPlusEnabled;
  }

  function renderPriorityPlus(cart) {
    var row = root.querySelector("[data-ap-cart-priority-plus]");
    var toggle = root.querySelector("[data-ap-cart-priority-plus-toggle]");
    var price = root.querySelector("[data-ap-cart-priority-plus-price]");
    if (!row || !toggle) return;
    var enabled = !isCanadaCart() && Boolean(root.dataset.priorityPlusVariantId) && eligibleItems(cart).length > 0;
    row.hidden = !enabled;
    toggle.checked = enabled && state.priorityPlusEnabled;
    row.classList.toggle("is-selected", toggle.checked);
    if (price) {
      var priceOff = price.querySelector(".ap-cart__priority-plus-price-off");
      var priceOn = price.querySelector(".ap-cart__priority-plus-price-on");
      if (priceOff) priceOff.textContent = root.dataset.priorityPlusPrice ? money(root.dataset.priorityPlusPrice) : "";
      if (priceOn) priceOn.textContent = root.dataset.priorityPlusPrice ? "+" + money(root.dataset.priorityPlusPrice) : "";
    }
  }

  function protectionPrice() {
    return Number(root.dataset.protectionPrice || 0);
  }

  function protectionItem(cart) {
    var variantId = root.dataset.protectionVariantId;
    if (!variantId || !cart) return null;
    return (cart.items || []).find(function (item) {
      return String(item.variant_id) === String(variantId);
    }) || null;
  }

  function checkoutUrl() {
    return localePath("/checkout");
  }

  function setCheckoutLoading(button, loading) {
    if (!button) return;
    var loadingLabel = button.querySelector("[data-ap-cart-checkout-loading]");
    button.disabled = loading;
    button.classList.toggle("is-busy", loading);
    button.setAttribute("aria-busy", loading ? "true" : "false");
    if (loadingLabel) loadingLabel.hidden = !loading;
  }

  function renderTotals(cart) {
    var subtotal = root.querySelector("[data-ap-cart-subtotal]");
    var checkoutTotal = root.querySelector("[data-ap-cart-checkout-total]");
    var checkoutCompare = root.querySelector("[data-ap-cart-checkout-compare]");
    var estimatedSavings = estimatedBundleSavings(cart);
    var displayedSubtotal = Math.max(0, eligibleCartTotal(cart) - estimatedSavings);
    if (subtotal) subtotal.textContent = money(displayedSubtotal);
    if (checkoutTotal) {
      var protection = protectionItem(cart);
      var priorityPlus = priorityPlusItem(cart);
      var priorityPlusAddOn = priorityPlusSelected(cart)
        ? Number(priorityPlus && (priorityPlus.final_line_price != null ? priorityPlus.final_line_price : priorityPlus.line_price) || root.dataset.priorityPlusPrice || 0)
        : 0;
      var protectionAddOn = !isCanadaCart() && root.dataset.protectionVariantId && eligibleItems(cart).length > 0
        ? Number(protection && (protection.final_line_price != null ? protection.final_line_price : protection.line_price) || protectionPrice())
        : 0;
      var total = displayedSubtotal + priorityPlusAddOn + protectionAddOn;
      checkoutTotal.textContent = money(total);
      if (checkoutCompare) { checkoutCompare.hidden = true; checkoutCompare.textContent = ""; }
    }
  }

  function cleanupOrphanProtection(cart) {
    var protection = protectionItem(cart);
    if (!protection || eligibleItems(cart).length > 0) {
      state.protectionCleanupKey = null;
      return;
    }
    if (state.protectionCleanupKey === protection.key) return;
    state.protectionCleanupKey = protection.key;
    changeLine(protection.key, 0).catch(function () {
      state.protectionCleanupKey = null;
    });
  }

  function cleanupDeselectedPriorityPlus(cart) {
    var item = priorityPlusItem(cart);
    if (!item || state.priorityPlusEnabled) {
      state.priorityPlusCleanupKey = null;
      return;
    }
    if (state.priorityPlusCleanupKey === item.key) return;
    state.priorityPlusCleanupKey = item.key;
    changeLine(item.key, 0).catch(function () {
      state.priorityPlusCleanupKey = null;
    });
  }

  function estimatedBundleSavings(cart) {
    if (!state.bundleGroupsLoaded) return 0;
    var counts = bundleGroupCounts(cart);
    return eligibleItems(cart).reduce(function (sum, item) {
      return sum + Math.max(0, estimatedBundleDiscountAmount(item, counts) - actualLineDiscountAmount(item));
    }, 0);
  }

  function bridgeLoyaltyWidget() {
    if (!root.classList.contains("is-enabled")) return;
    var host = root.querySelector("[data-ap-cart-loyalty]");
    if (!host) return;
    ensureLoyaltyAccordion(host);
    holdLegacyLoyaltyBridge();
    var widget = findLoyaltyWidget();
    if (!widget) return;
    var panel = host.querySelector("[data-ap-cart-loyalty-panel]") || host;
    if (!panel.contains(widget)) panel.appendChild(widget);
    holdLegacyLoyaltyBridge();
    if (state.cart) widget.dataset.cartPrice = String(Number(state.cart.total_price || 0));
    widget.style.setProperty("display", "flex", "important");
    widget.style.setProperty("width", "100%", "important");
    widget.style.setProperty("margin", "0", "important");
    widget.style.setProperty("box-sizing", "border-box", "important");
    host.hidden = false;
    syncLoyaltyAccordion(host);
  }

  function ensureLoyaltyAccordion(host) {
    if (host.querySelector("[data-ap-cart-loyalty-toggle]")) return;
    var existing = Array.prototype.slice.call(host.childNodes);
    var toggle = document.createElement("button");
    toggle.className = "ap-cart__loyalty-toggle";
    toggle.type = "button";
    toggle.setAttribute("data-ap-cart-loyalty-toggle", "true");
    toggle.setAttribute("aria-expanded", "false");
    toggle.innerHTML = [
      '<span>' + escapeHtml(text("rewards", "Rewards")) + '</span>',
      '<svg class="ap-cart__loyalty-chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>'
    ].join("");
    var panel = document.createElement("div");
    panel.className = "ap-cart__loyalty-panel";
    panel.setAttribute("data-ap-cart-loyalty-panel", "true");
    panel.hidden = true;
    existing.forEach(function (node) {
      panel.appendChild(node);
    });
    host.textContent = "";
    host.setAttribute("data-ap-loyalty-expanded", "false");
    host.appendChild(toggle);
    host.appendChild(panel);
  }

  function syncLoyaltyAccordion(host) {
    var expanded = host.getAttribute("data-ap-loyalty-expanded") === "true";
    var toggle = host.querySelector("[data-ap-cart-loyalty-toggle]");
    var panel = host.querySelector("[data-ap-cart-loyalty-panel]");
    if (toggle) toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    if (panel) panel.hidden = !expanded;
  }

  function toggleLoyaltyAccordion() {
    var host = root.querySelector("[data-ap-cart-loyalty]");
    if (!host) return;
    var expanded = host.getAttribute("data-ap-loyalty-expanded") === "true";
    host.setAttribute("data-ap-loyalty-expanded", expanded ? "false" : "true");
    syncLoyaltyAccordion(host);
  }

  function holdLegacyLoyaltyBridge() {
    var upnova = document.querySelector("upnova-widget");
    var shadowRoot = upnova && upnova.shadowRoot;
    var legacyHost = shadowRoot && shadowRoot.querySelector("[data-essential-loyalty-upez-host]");
    if (!legacyHost) return;
    if (!legacyHost.querySelector("[data-ap-cart-loyalty-sentinel]")) {
      var sentinel = document.createElement("span");
      sentinel.setAttribute("data-ap-cart-loyalty-sentinel", "true");
      sentinel.hidden = true;
      sentinel.textContent = "points";
      legacyHost.appendChild(sentinel);
    }
  }

  function findLoyaltyWidget() {
    var widget = document.querySelector(".honeypop-cp");
    if (widget) return widget;

    var stage = document.getElementById("essential-loyalty-cart-stage");
    if (stage) {
      widget = Array.prototype.find.call(stage.children, function (el) {
        return el.classList && el.classList.contains("honeypop-cp");
      });
      if (widget) return widget;
    }

    var upnova = document.querySelector("upnova-widget");
    var shadowRoot = upnova && upnova.shadowRoot;
    return shadowRoot ? shadowRoot.querySelector(".honeypop-cp") : null;
  }

  function startLoyaltyBridgeLoop() {
    var attempts = 0;
    window.clearInterval(state.loyaltyTimer);
    bridgeLoyaltyWidget();
    state.loyaltyTimer = window.setInterval(function () {
      attempts += 1;
      bridgeLoyaltyWidget();
      if (!root.classList.contains("is-open") || attempts > 20) {
        window.clearInterval(state.loyaltyTimer);
      }
    }, 250);
  }

  function renderCount(cart) {
    var count = root.querySelector("[data-ap-cart-count]");
    var visibleCount = eligibleItems(cart).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
    if (count) count.textContent = String(visibleCount);
    document.querySelectorAll(".cart-count-bubble span[aria-hidden='true']").forEach(function (el) {
      el.textContent = String(visibleCount);
    });
  }

  function render(cart) {
    renderCount(cart);
    renderShipping(cart);
    // Aroma Deal Days (v26): Mystery Gift ladder + auto-managed gift line. No-op unless the event's gift flag is on
    // (assets/ap-deal-days-gifts.js is only loaded then) and the gift products resolve.
    if (window.APDDGifts) window.APDDGifts.drawer(root, cart);
    renderBundleProgress(cart);
    renderSizeUpgrade(cart);
    renderItems(cart);
    // End of Fall Sale (2026-10-16): $9.99 diffuser offer card under the items. No-op when the sale is off.
    if (window.APFallSaleCart) window.APFallSaleCart.drawer(root, cart);
    renderCompatibilityWarning(cart);
    renderMembershipPrompt(cart);
    renderRoomMistUpsell(cart);
    hydrateBundleSuggestionVisibility(cart);
    renderPriorityPlus(cart);
    renderProtection(cart);
    renderTotals(cart);
    // Aroma Prime Week (v26): event band, compare-at "Was" prices and the savings row. No-op when the event is off.
    if (window.APDDCart) window.APDDCart.decorate(root, cart);
    cleanupOrphanProtection(cart);
    cleanupOrphanGifts(cart);
    cleanupDeselectedPriorityPlus(cart);
    bridgeLoyaltyWidget();
    if (eligibleItems(cart).length && (!state.bundleGroupsLoaded || !state.cartGroupsLoaded)) {
      primeCartUpsells(cart);
    } else {
      scheduleRecommendations(cart);
    }
  }

  function scheduleRecommendations(cart) {
    window.clearTimeout(state.recsTimer);
    state.recsTimer = window.setTimeout(function () {
      renderRecommendations(cart);
    }, root.classList.contains("is-open") ? 120 : 320);
  }

  function renderRoomMistUpsell(cart) {
    var section = root.querySelector("[data-ap-cart-room-mist]");
    var track = root.querySelector("[data-ap-cart-room-mist-track]");
    if (!section || !track) return;
    var items = eligibleItems(cart);
    if (!items.length || cartHasProduct(cart, state.roomMistUpsellProduct && state.roomMistUpsellProduct.id)) {
      section.hidden = true;
      track.innerHTML = "";
      return;
    }
    if (state.roomMistUpsellUnavailable) {
      section.hidden = true;
      track.innerHTML = "";
      return;
    }
    if (!state.roomMistUpsellProduct) {
      loadRoomMistUpsell().then(function () {
        if (state.cart) renderRoomMistUpsell(state.cart);
      });
      section.hidden = true;
      return;
    }
    if (state.roomMistUpsellProduct.available === false) {
      section.hidden = true;
      track.innerHTML = "";
      return;
    }
    if (cartHasProduct(cart, state.roomMistUpsellProduct.id)) {
      section.hidden = true;
      track.innerHTML = "";
      return;
    }
    track.innerHTML = renderRoomMistUpsellCard(state.roomMistUpsellProduct);
    section.hidden = false;
  }

  function renderRoomMistUpsellCard(product) {
    var variant = product && product.variants && product.variants[0];
    if (!product || !variant) return "";
    var productUrl = localePath(product.url || ("/products/" + product.handle));
    var image = productImage(product);
    var price = productPrice(product, variant);
    return [
      '<article class="ap-cart__room-mist-card" data-ap-cart-rec="room-mist" data-ap-cart-rec-product="' + escapeHtml(product.id) + '">',
        image ? '<a class="ap-cart__room-mist-media" href="' + escapeHtml(productUrl) + '" aria-label="' + escapeHtml(formatText("view_product", "View __PRODUCT__", { product: product.title })) + '"><img src="' + escapeHtml(imageUrl(image, 180)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></a>' : "",
        '<div class="ap-cart__room-mist-main">',
          '<a class="ap-cart__room-mist-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(premiumTitle(product.title).replace(/\s*Spray$/i, "")) + '</a>',
          '<p><strong>' + (price ? escapeHtml(price) : "") + '</strong> · ' + escapeHtml(text("instant_refresh", "instant refresh for rooms and entryways")) + '</p>',
        '</div>',
        '<button type="button" class="ap-cart__room-mist-add" data-ap-cart-add-rec="room-mist" data-ap-cart-add-variant="' + escapeHtml(variant.id) + '" aria-label="' + escapeHtml(formatText("add_product_to_cart", "Add __PRODUCT__ to cart", { product: product.title })) + '">+</button>',
      '</article>'
    ].join("");
  }

  function loadRoomMistUpsell() {
    if (state.roomMistUpsellProduct || state.roomMistUpsellUnavailable) return Promise.resolve(state.roomMistUpsellProduct);
    if (state.roomMistUpsellLoading) return state.roomMistUpsellLoading;
    state.roomMistUpsellLoading = fetch(localePath("/products/" + encodeURIComponent(ROOM_MIST_UPSELL_HANDLE) + ".js"), {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).then(function (product) {
      if (!product || product.available === false || !product.variants || !product.variants.length) {
        state.roomMistUpsellUnavailable = true;
        return null;
      }
      state.roomMistUpsellProduct = product;
      return product;
    }).catch(function () {
      state.roomMistUpsellUnavailable = true;
      return null;
    }).finally(function () {
      state.roomMistUpsellLoading = null;
    });
    return state.roomMistUpsellLoading;
  }

  function cartHasProduct(cart, productId) {
    if (!productId) return false;
    return eligibleItems(cart || { items: [] }).some(function (item) {
      return String(item.product_id) === String(productId);
    });
  }

  function renderRecommendations(cart) {
    var hasGroupRecommendations = renderGroupRecommendations();
    var hasBundleSuggestions = renderBundleSuggestions(cart);
    var hasInlineRecommendations = hasGroupRecommendations || hasBundleSuggestions;
    if (hasInlineRecommendations) {
      var fallbackSection = root.querySelector("[data-ap-cart-recs]");
      var fallbackTrack = root.querySelector("[data-ap-cart-recs-track]");
      if (fallbackSection) fallbackSection.hidden = true;
      if (fallbackTrack) fallbackTrack.innerHTML = "";
      return;
    }
    var first = recommendationSourceItem(cart);
    var section = root.querySelector("[data-ap-cart-recs]");
    var track = root.querySelector("[data-ap-cart-recs-track]");
    if (!section || !track) return;
    if (!first || !first.product_id) {
      section.hidden = true;
      track.innerHTML = "";
      return;
    }
    if (state.recommendationsFor === first.product_id) return;
    state.recommendationsFor = first.product_id;
    section.hidden = true;
    track.innerHTML = "";
    if (state.recommendationsAbort) state.recommendationsAbort.abort();
    state.recommendationsAbort = new AbortController();
    fetch(localePath("/recommendations/products.json") + "?product_id=" + encodeURIComponent(first.product_id) + "&limit=6&intent=complementary", {
      credentials: "same-origin",
      signal: state.recommendationsAbort.signal,
      headers: { "Accept": "application/json" }
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).then(function (payload) {
      var products = payload && payload.products ? payload.products : [];
      return filterRecommendationProducts(products, first.product_id);
    }).then(function (products) {
      products = products || [];
      if (!products.length) return;
      return Promise.all(products.map(enrichProduct)).then(function (enriched) {
        var cards = enriched.map(function (product, index) {
          return renderRecommendationCard(product, index);
        });
        track.innerHTML = cards.join("");
        section.hidden = false;
      });
    }).catch(function () {});
  }

  function renderBundleSuggestions(cart) {
    var sections = Array.prototype.slice.call(root.querySelectorAll("[data-ap-cart-bundle-suggestions]"));
    if (!sections.length) return false;
    var cartProductIds = cartProductIdSet(cart);
    sections.forEach(function (section) {
      var groupKey = section.getAttribute("data-ap-cart-bundle-suggestions");
      var handle = section.getAttribute("data-ap-cart-bundle-handle");
      var track = root.querySelector('[data-ap-cart-bundle-suggestions-track="' + cssEscape(groupKey) + '"]');
      if (!groupKey || !handle || !track) return;
      hideCartSuggestionCards(track, cartProductIds);
      var cacheKey = groupKey + ":" + handle;
      if (state.bundleSuggestions[groupKey] === cacheKey && track.children.length) {
        if (hasVisibleSuggestionCards(track)) {
          section.hidden = false;
          return;
        }
      }
      state.bundleSuggestions[groupKey] = cacheKey;
      if (!track.children.length) section.hidden = true;
      if (state.bundleSuggestionAborts[groupKey]) state.bundleSuggestionAborts[groupKey].abort();
      state.bundleSuggestionAborts[groupKey] = new AbortController();
      fetch(localePath("/collections/" + encodeURIComponent(handle) + "/products.json") + "?limit=12", {
        credentials: "same-origin",
        signal: state.bundleSuggestionAborts[groupKey].signal,
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        return filterCollectionSuggestionProducts(products, cartProductIds);
      }).then(function (products) {
        products = products || [];
        if (!products.length) return;
        track.innerHTML = products.slice(0, 6).map(function (product, index) {
          return renderRecommendationCard(product, index);
        }).join("");
        state.bundleSuggestionHtml[groupKey] = track.innerHTML;
        hideCartSuggestionCards(track, cartProductIds);
        section.hidden = false;
      }).catch(function () {});
    });
    return true;
  }

  function primeCartUpsells(cart) {
    if (!cart || !eligibleItems(cart).length) return;
    var key = eligibleItems(cart).map(function (item) {
      return [item.product_id || "", item.variant_id || "", item.quantity || 0].join(":");
    }).join("|");
    if (!key || state.recommendationsPrimedFor === key) return;
    state.recommendationsPrimedFor = key;
    loadCartGrouping().then(function () {
      if (state.cart) scheduleRecommendations(state.cart);
    }).catch(function () {});
  }

  function hydrateBundleSuggestionVisibility(cart) {
    var cartProductIds = cartProductIdSet(cart);
    Array.prototype.slice.call(root.querySelectorAll("[data-ap-cart-bundle-suggestions]")).forEach(function (section) {
      var groupKey = section.getAttribute("data-ap-cart-bundle-suggestions");
      var track = root.querySelector('[data-ap-cart-bundle-suggestions-track="' + cssEscape(groupKey) + '"]');
      if (!track || !track.children.length) return;
      hideCartSuggestionCards(track, cartProductIds);
      section.hidden = !hasVisibleSuggestionCards(track);
    });
  }

  function hideCartSuggestionCards(track, cartProductIds) {
    if (!track) return;
    Array.prototype.slice.call(track.querySelectorAll("[data-ap-cart-rec-product]")).forEach(function (card) {
      var productId = card.getAttribute("data-ap-cart-rec-product");
      card.hidden = !!cartProductIds[String(productId)];
    });
  }

  function hasVisibleSuggestionCards(track) {
    if (!track) return false;
    return Array.prototype.slice.call(track.querySelectorAll("[data-ap-cart-rec-product]")).some(function (card) {
      return !card.hidden;
    });
  }

  function cartProductIdSet(cart) {
    var ids = {};
    eligibleItems(cart || { items: [] }).forEach(function (item) {
      if (item && item.product_id) ids[String(item.product_id)] = true;
    });
    return ids;
  }

  function filterCollectionSuggestionProducts(products, cartProductIds) {
    return (products || []).filter(function (product) {
      return product
        && product.id
        && !cartProductIds[String(product.id)]
        && product.available !== false
        && product.variants
        && product.variants[0];
    });
  }

  function renderGroupRecommendations() {
    var sections = Array.prototype.slice.call(root.querySelectorAll("[data-ap-cart-group-recs]"));
    if (!sections.length) return false;
    sections.forEach(function (section) {
      var groupKey = section.getAttribute("data-ap-cart-group-recs");
      var sourceProductId = section.getAttribute("data-ap-cart-group-recs-source");
      var track = root.querySelector('[data-ap-cart-group-recs-track="' + cssEscape(groupKey) + '"]');
      if (!groupKey || !sourceProductId || !track) return;
      var cacheKey = groupKey + ":" + sourceProductId;
      if (state.groupRecommendations[groupKey] === cacheKey && track.children.length) return;
      state.groupRecommendations[groupKey] = cacheKey;
      section.hidden = true;
      track.innerHTML = "";
      if (state.groupRecommendationAborts[groupKey]) state.groupRecommendationAborts[groupKey].abort();
      state.groupRecommendationAborts[groupKey] = new AbortController();
      fetch(localePath("/recommendations/products.json") + "?product_id=" + encodeURIComponent(sourceProductId) + "&limit=6&intent=complementary", {
        credentials: "same-origin",
        signal: state.groupRecommendationAborts[groupKey].signal,
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        if (groupKey === "waterless-diffusers") {
          products = products.filter(function (product) {
            return product && product.handle !== WATERLESS_CLEANER_UPSELL_HANDLE;
          });
        }
        return filterRecommendationProducts(products, sourceProductId);
      }).then(function (products) {
        products = products || [];
        if (!products.length) return;
        return Promise.all(products.map(enrichProduct)).then(function (enriched) {
          track.innerHTML = enriched.map(function (product, index) {
            return renderRecommendationCard(product, index);
          }).join("");
          section.hidden = false;
        });
      }).catch(function () {});
    });
    return true;
  }

  function filterRecommendationProducts(products, sourceProductId) {
    return (products || []).filter(function (product) {
      return product
        && String(product.id) !== String(sourceProductId)
        && product.available !== false
        && product.variants
        && product.variants[0];
    }).slice(0, 6);
  }

  function recommendationSourceItem(cart) {
    var items = eligibleItems(cart);
    if (!items.length) return null;
    return items[0];
  }

  function productJsonUrl(product) {
    if (product && product.handle) return localePath("/products/" + encodeURIComponent(product.handle) + ".js");
    if (product && product.url) return localePath(product.url.split("?")[0].replace(/\/$/, "") + ".js");
    return "";
  }

  function enrichProduct(product) {
    var url = productJsonUrl(product);
    if (!url) return Promise.resolve(product);
    return fetch(url, {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (res) {
      return res.ok ? res.json() : product;
    }).then(function (fullProduct) {
      return Object.assign({}, product, fullProduct || {});
    }).catch(function () {
      return product;
    });
  }

  function variantOptions(product, recId) {
    var variants = (product.variants || []).filter(function (variant) {
      return variant && variant.available !== false;
    });
    if (!variants.length) return "";
    return [
      '<label class="ap-cart__rec-control">',
        '<span class="visually-hidden">' + escapeHtml(text("variant", "Variant")) + '</span>',
        '<select data-ap-cart-rec-variant="' + escapeHtml(recId) + '">',
          variants.map(function (variant) {
            return '<option value="' + escapeHtml(variant.id) + '" data-price="' + escapeHtml(normalizePrice(variant.price)) + '">' + escapeHtml(variant.title || text("default_variant", "Default")) + '</option>';
          }).join(""),
        '</select>',
      '</label>'
    ].join("");
  }

  // cart-simplify-2026-10-13: short cart-line names. "Aman Tokyo Inspired Waterless Fragrance Oil – … – For Cold-Air Diffusers -
  // Tokyo Radiance" -> name "Tokyo Radiance", sub "Aman Tokyo inspired"; "Tower Pro Waterless Cold-Air … | Large Space"
  // -> "Tower Pro Diffuser". Anything the rules cannot shorten keeps its full title.
  function cartItemName(title) {
    var full = String(title || "").replace(/\s+/g, " ").trim();
    var name = full;
    var sub = "";
    var apName = full.match(/\bFor [^|–]*Diffusers?\s+[-–]\s+([^|–]+?)\s*$/i);
    var base = full.split(/\s+[|–—]\s+|\s+-\s+/)[0];
    var inspired = base.match(/^(.+?)\s+(?:Perfume\s+)?Inspired\b/i);
    var source = inspired ? inspired[1].replace(/\s+(?:Perfume|Fall|Christmas)$/i, "").trim() : "";
    if (apName) {
      name = apName[1];
      if (source) sub = formatText("inspired_by_source", "__SOURCE__ inspired", { source: source });
    } else if (source) {
      name = formatText("inspired_by_source", "__SOURCE__ inspired", { source: source });
    } else {
      name = base
        .replace(/\s+(?:Premium\s+)?Long-Lasting\b.*$/i, "")
        .replace(/\s+(?:Smart\s+)?(?:Plug-In\s+)?(?:Rechargeable\s+)?(?:Dual-Nozzle\s+)?(?:Waterless|Cold[- ]Air|Ultrasonic|Humidifying)\b.*$/i, function (match) {
          return /diffuser/i.test(match) ? " " + text("diffuser", "Diffuser") : "";
        })
        .replace(/\s+(?:Waterless\s+)?Fragrance Oil$/i, "")
        .replace(/\s+Bambooless\s+Incense\s+Sticks?$/i, " " + text("incense_name", "Incense"))
        .trim();
    }
    var packLabel = full.match(/\s[-–]\s(\d+-Oil Collection)\s*$/i);
    if (packLabel && !sub) sub = packLabel[1];
    if (!name || name.length < 3) name = full;
    return { name: name, sub: sub, full: full };
  }

  function premiumTitle(title) {
    return String(title || "")
      .replace(/\s*[|-]\s*Premium Long-Lasting.*$/i, "")
      .replace(/\s*Premium Long-Lasting.*$/i, "")
      .replace(/\s*Perfume Inspired.*$/i, "")
      .replace(/\s*Inspired By.*$/i, "")
      .replace(/\s*For Humidifying Diffusers.*$/i, "")
      .replace(/\s*Waterless Fragrance Oil.*$/i, "")
      .replace(/\s*Fragrance Oil.*$/i, "")
      .replace(/\s*[–—-]\s*$/g, "")
      .trim();
  }

  function discountBadge(price, compare) {
    price = normalizePrice(price);
    compare = normalizePrice(compare);
    if (!price || !compare || compare <= price) return "";
    return '<span class="ap-cart__rec-badge">-' + Math.round(((compare - price) / compare) * 100) + '%</span>';
  }

  function renderRecommendationCard(product, index) {
        var variant = product.variants[0];
        var image = productImage(product);
        var price = productPrice(product, variant);
        var recId = "rec-" + index + "-" + String(product.id || product.handle || variant.id).replace(/[^a-zA-Z0-9_-]/g, "");
        var productUrl = localePath(product.url || ("/products/" + product.handle));
        var compare = normalizePrice((variant && variant.compare_at_price) || product.compare_at_price);
        var comparePrice = compare && compare > normalizePrice(variant.price)
          ? '<span class="ap-cart__rec-compare">' + money(compare) + '</span>'
          : "";
        return [
          '<article class="ap-cart__rec" data-ap-cart-rec="' + escapeHtml(recId) + '" data-ap-cart-rec-product="' + escapeHtml(product.id) + '">',
            '<a class="ap-cart__rec-media" href="' + escapeHtml(productUrl) + '" aria-label="' + escapeHtml(formatText("view_product", "View __PRODUCT__", { product: product.title })) + '">',
              image ? '<img src="' + escapeHtml(imageUrl(image, 320)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : "",
            '</a>',
            '<div class="ap-cart__rec-main">',
              '<a class="ap-cart__rec-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(premiumTitle(product.title)) + '</a>',
              '<div class="ap-cart__rec-rating" aria-label="' + escapeHtml(text("customer_rating", "Customer rating")) + '"><span aria-hidden="true">★★★★★</span></div>',
              variantOptions(product, recId),
            '</div>',
            '<div class="ap-cart__rec-side">',
              '<p class="ap-cart__rec-price" data-ap-cart-rec-price>' + (price ? escapeHtml(price) : '&nbsp;') + comparePrice + '</p>',
              '<button type="button" class="ap-cart__rec-add" data-ap-cart-add-rec="' + escapeHtml(recId) + '" data-ap-cart-add-variant="' + escapeHtml(variant.id) + '" aria-label="' + escapeHtml(formatText("add_product_to_cart", "Add __PRODUCT__ to cart", { product: product.title })) + '">',
                '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6.5 7h13l-1.4 8.2a2 2 0 0 1-2 1.7H9.3a2 2 0 0 1-2-1.7L6.1 4.8H3.8"/><circle cx="9.7" cy="20" r="1.1"/><circle cx="16.7" cy="20" r="1.1"/></svg>',
              '</button>',
            '</div>',
          '</article>'
        ].join("");
  }

  function productImage(product) {
    var image = product && (product.featured_image || product.image || (product.images && product.images[0]));
    if (image && image.src) return image.src;
    return image || "";
  }

  // Aroma Prime Week mystery gifts outside the event (edge-case audit 2026-10-03). When the gift script is not loaded
  // (event ended or switched off, gift flag off, or a non-US market) a gift line must never linger as a $0 item a
  // shopper could raise the quantity of: hide it and remove it from the cart. Handles + the _dd_gift property.
  var ORPHAN_GIFT_HANDLES = { "silver-mystery-gift": 1, "gold-mystery-gift": 1 };
  var orphanGiftTried = {};
  function isOrphanGift(item) {
    if (window.APDDGifts) return false;
    return Boolean(item && ((ORPHAN_GIFT_HANDLES || {})[item.handle] || (item.properties && item.properties._dd_gift)));
  }
  function removeOrphanGifts(cart) {
    var lines = (cart && cart.items || []).filter(isOrphanGift);
    if (!lines.length) return Promise.resolve(false);
    var sig = lines.map(function (i) { return i.key + ":" + i.quantity; }).join(",");
    if (orphanGiftTried[sig]) return Promise.resolve(false);
    orphanGiftTried[sig] = true;
    var updates = {};
    lines.forEach(function (i) { updates[i.key] = 0; });
    return api(localePath("/cart/update.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates })
    }).then(function () { return true; }).catch(function () { return false; });
  }
  function cleanupOrphanGifts(cart) {
    removeOrphanGifts(cart).then(function (changed) { if (changed) fetchCart(); });
  }

  function checkout(withProtection) {
    // Gifts first: the event script settles the gift line to the cart (earned added, unearned removed); with no
    // event script any leftover gift is removed. Then the original checkout flow runs on the server's cart.
    var pre = window.APDDGifts && window.APDDGifts.settle ? window.APDDGifts.settle() : api(localePath("/cart.js")).then(function (cart) {
      var updates = {};
      (cart.items || []).filter(isOrphanGift).forEach(function (item) { updates[item.key] = 0; });
      if (!Object.keys(updates).length) return cart;
      return api(localePath("/cart/update.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates })
      }).then(function () { return api(localePath("/cart.js")); }).then(function (next) {
        if ((next.items || []).some(isOrphanGift)) throw new Error("Mystery gift removal could not be confirmed.");
        return next;
      });
    });
    return Promise.resolve(pre).then(function (cart) {
      if (cart && cart.items) state.cart = cart;
      return checkoutAfterGifts(withProtection);
    });
  }

  function checkoutAfterGifts(withProtection) {
    var cart = state.cart || { items: [] };
    if (!eligibleItems(cart).length) {
      showError(text("empty_checkout_error", "Add an item to your cart before checkout."));
      return Promise.resolve();
    }
    rememberCheckoutReturnPath();
    var updates = {};
    if (root.dataset.priorityPlusVariantId) {
      updates[root.dataset.priorityPlusVariantId] = priorityPlusSelected(cart) ? 1 : 0;
    }
    if (root.dataset.protectionVariantId) {
      updates[root.dataset.protectionVariantId] = withProtection ? 1 : 0;
    }
    if (!Object.keys(updates).length) {
      window.location.href = checkoutUrl();
      return Promise.resolve();
    }
    var startedAt = Date.now();
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var timeoutId = controller ? window.setTimeout(function () {
      controller.abort();
    }, 2000) : null;
    return api(localePath("/cart/update.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates }),
      signal: controller ? controller.signal : undefined
    }).catch(function (error) {
      trackCartEvent("checkout_update_failed", {
        checkout_plus: withProtection,
        priority_plus: priorityPlusSelected(cart),
        duration_ms: Date.now() - startedAt,
        reason: error && error.name === "AbortError" ? "timeout" : "request_failed"
      });
    }).finally(function () {
      if (timeoutId) window.clearTimeout(timeoutId);
      window.location.href = checkoutUrl();
    });
  }

  function bindEvents() {
    document.addEventListener("submit", function (event) {
      if (!root.classList.contains("is-enabled")) return;
      var form = event.target && event.target.closest && event.target.closest("form[action*='/cart/add']");
      if (!form || form.closest("[data-ap-cart]")) return;
      event.preventDefault();
      event.stopPropagation();
      submitProductAddForm(form);
    }, true);

    root.addEventListener("click", function (event) {
      var tbAct = event.target.closest("[data-ap-tb-act]");
      if (tbAct) {
        trackCartEvent("bundle_card_action", { action: tbAct.getAttribute("data-ap-tb-act") });
        if (tbAct.getAttribute("data-ap-tb-act") === "copy") { event.preventDefault(); tbDuplicate(tbAct.getAttribute("data-ap-tb-key"), tbAct.getAttribute("href")); return; }
      }
      var close = event.target.closest("[data-ap-cart-close]");
      if (close) {
        event.preventDefault();
        closeCart();
        return;
      }
      var importDutyInfo = event.target.closest("[data-ap-cart-import-duty] .ap-cart__info");
      if (importDutyInfo) {
        event.preventDefault();
        importDutyInfo.setAttribute("aria-expanded", importDutyInfo.getAttribute("aria-expanded") === "true" ? "false" : "true");
        return;
      }
      var sizeUpgradeReview = event.target.closest("[data-ap-cart-size-upgrade-review]");
      if (sizeUpgradeReview) {
        event.preventDefault();
        state.sizeUpgradeExpanded = !state.sizeUpgradeExpanded;
        var sizeUpgradeMount = root.querySelector("[data-ap-cart-size-upgrade]");
        if (state.cart) renderSizeUpgrade(state.cart);
        trackCartEvent("size_upgrade_review_toggled", {
          expanded: state.sizeUpgradeExpanded,
          eligible_lines: sizeUpgradeMount && sizeUpgradeMount.__apSizeUpgradePlan ? sizeUpgradeMount.__apSizeUpgradePlan.lines.length : 0,
          surface: "upgrade_all"
        });
        return;
      }
      var sizeUpgradeAll = event.target.closest("[data-ap-cart-size-upgrade-all]");
      if (sizeUpgradeAll) {
        event.preventDefault();
        var upgradeMount = root.querySelector("[data-ap-cart-size-upgrade]");
        executeSizeUpgrade(upgradeMount && upgradeMount.__apSizeUpgradePlan);
        return;
      }
      if (event.target.closest("[data-ap-cart-size-upgrade-undo]")) {
        event.preventDefault();
        undoSizeUpgrade();
        return;
      }
      if (event.target.closest("[data-ap-cart-removal-undo]")) {
        event.preventDefault();
        undoRemoval();
        return;
      }
      var subOn = event.target.closest("[data-ap-sub-switch]");
      if (subOn) {
        event.preventDefault();
        subOn.setAttribute("aria-pressed", "true");
        subSetPlan(subOn.getAttribute("data-ap-sub-switch"), subOn.getAttribute("data-plan"), subOn.getAttribute("data-variant"), "switch");
        return;
      }
      var subUndo = event.target.closest("[data-ap-sub-undo]");
      if (subUndo) {
        event.preventDefault();
        subSetPlan(subUndo.getAttribute("data-ap-sub-undo"), null, subUndo.getAttribute("data-variant"), "undo");
        return;
      }
      var qty = event.target.closest("[data-ap-cart-qty]");
      if (qty) {
        event.preventDefault();
        var lineKey = qty.getAttribute("data-ap-cart-qty");
        var nextQty = Number(qty.getAttribute("data-qty"));
        var currentLine = cartLineByKey(lineKey);
        var previousQty = currentLine ? Number(currentLine.quantity || 0) : null;
        setLineBusy(lineKey, true);
        changeLine(lineKey, nextQty, nextQty <= 0 ? currentLine : null).then(function () {
          trackCartEvent(nextQty <= 0 ? "cart_item_removed" : "cart_quantity_changed", {
            line_key: lineKey,
            quantity: nextQty,
            previous_quantity: previousQty,
            product_id: currentLine && currentLine.product_id ? currentLine.product_id : "",
            variant_id: currentLine && currentLine.variant_id ? currentLine.variant_id : "",
            product_title: currentLine && currentLine.product_title ? currentLine.product_title : ""
          });
        }).catch(function () {
          showError(text("item_update_error", "We couldn't update this item. Please try again."));
        }).finally(function () {
          setLineBusy(lineKey, false);
        });
        return;
      }
      var add = event.target.closest("[data-ap-cart-add-variant]");
      if (add) {
        event.preventDefault();
        var originalLabel = add.textContent;
        var isIconButton = add.classList.contains("ap-cart__rec-add") || add.classList.contains("ap-cart__room-mist-add") || add.classList.contains("ap-cart__line-cleaner-add");
        var recCard = add.closest("[data-ap-cart-rec]");
        if (recCard) {
          recCard.classList.remove("is-adding", "is-added");
          void recCard.offsetWidth;
          recCard.classList.add("is-adding");
        }
        setCartMutating(true);
        add.disabled = true;
        add.classList.add("is-busy");
        if (!isIconButton) add.textContent = text("adding", "Adding");
        addVariant(add.getAttribute("data-ap-cart-add-variant"), 1).then(function () {
          var recSource = recommendationSource(recCard);
          var recPayload = Object.assign({
            variant_id: add.getAttribute("data-ap-cart-add-variant") || "",
            recommendation_id: recCard ? recCard.getAttribute("data-ap-cart-rec") || "" : "",
            product_id: recCard ? recCard.getAttribute("data-ap-cart-rec-product") || "" : ""
          }, recSource);
          trackCartEvent("recommendation_added", recPayload);
          if (recSource.source === "bundle_suggestion") {
            trackCartEvent("bundle_suggestion_added", recPayload);
          }
          if (recSource.source === "room_mist_upsell") {
            trackCartEvent("room_mist_upsell_added", recPayload);
          }
          if (recSource.source === "humidifying_cleaner_upsell") {
            trackCartEvent("humidifying_cleaner_upsell_added", recPayload);
          }
          if (recSource.source === "waterless_cleaner_upsell") {
            trackCartEvent("waterless_cleaner_upsell_added", recPayload);
          }
          if (recSource.source === "fragrance_dropper_upsell") {
            trackCartEvent("fragrance_dropper_upsell_added", recPayload);
          }
          if (!isIconButton) add.textContent = text("added", "Added");
          add.classList.add("is-added");
          if (recCard) {
            recCard.classList.remove("is-added");
            void recCard.offsetWidth;
            recCard.classList.add("is-added");
          }
        }).catch(function () {
          showError(text("add_error", "We couldn't add that product. Please try again."));
          if (!isIconButton) add.textContent = originalLabel;
        }).finally(function () {
          window.setTimeout(function () {
            add.disabled = false;
            add.classList.remove("is-busy");
            add.classList.remove("is-added");
            if (recCard) recCard.classList.remove("is-adding", "is-added");
            setCartMutating(false);
            if (!isIconButton) add.textContent = originalLabel;
          }, 700);
        });
        return;
      }
      if (event.target.closest("[data-ap-cart-loyalty-toggle]")) {
        event.preventDefault();
        toggleLoyaltyAccordion();
        var loyaltyHost = root.querySelector("[data-ap-cart-loyalty]");
        trackCartEvent("rewards_toggled", {
          expanded: loyaltyHost ? loyaltyHost.getAttribute("data-ap-loyalty-expanded") === "true" : false
        });
        return;
      }
      var mergedButton = event.target.closest("[data-ap-cart-merged-prev], [data-ap-cart-merged-next]");
      if (mergedButton) {
        event.preventDefault();
        var mergedTrack = root.querySelector("[data-ap-cart-merged-track]");
        var mergedDirection = mergedButton.hasAttribute("data-ap-cart-merged-prev") ? -1 : 1;
        if (mergedTrack) {
          mergedTrack.scrollBy({
            left: mergedDirection * Math.max(150, Math.round(mergedTrack.clientWidth * 0.82)),
            behavior: "smooth"
          });
        }
        return;
      }
      if (event.target.closest("[data-ap-cart-recs-prev], [data-ap-cart-recs-next]")) {
        event.preventDefault();
        var track = root.querySelector("[data-ap-cart-recs-track]");
        var direction = event.target.closest("[data-ap-cart-recs-prev]") ? -1 : 1;
        if (track) {
          track.scrollBy({
            left: direction * Math.max(150, Math.round(track.clientWidth * 0.82)),
            behavior: "smooth"
          });
        }
        return;
      }
      if (event.target.closest("[data-ap-cart-checkout-plus]")) {
        event.preventDefault();
        var checkoutButton = event.target.closest("[data-ap-cart-checkout-plus]");
        if (checkoutButton.classList.contains("is-busy")) return;
        var withProtection = !isCanadaCart();
        setCheckoutLoading(checkoutButton, true);
        trackCartEvent(withProtection ? "checkout_plus_clicked" : "checkout_clicked", { checkout_plus: withProtection });
        checkout(withProtection).catch(function () {
          setCheckoutLoading(checkoutButton, false);
          showError(text("checkout_error", "Checkout couldn't start. Please try again."));
        });
        return;
      }
      if (event.target.closest("[data-ap-cart-checkout-without]")) {
        event.preventDefault();
        var withoutButton = event.target.closest("[data-ap-cart-checkout-without]");
        if (withoutButton.classList.contains("is-busy")) return;
        withoutButton.classList.add("is-busy");
        trackCartEvent("continue_without_checkout_plus", { checkout_plus: false });
        checkout(false).catch(function () {
          withoutButton.classList.remove("is-busy");
          showError(text("checkout_error", "Checkout couldn't start. Please try again."));
        });
      }
    });

    root.addEventListener("change", function (event) {
      var subFreq = event.target.closest("[data-ap-sub-freq]");
      if (subFreq) {
        subSetPlan(subFreq.getAttribute("data-ap-sub-freq"), subFreq.value, subFreq.getAttribute("data-variant"), "frequency");
        return;
      }
      var priorityPlusToggle = event.target.closest("[data-ap-cart-priority-plus-toggle]");
      if (priorityPlusToggle) {
        writePriorityPlusPreference(priorityPlusToggle.checked);
        var priorityPlusRow = root.querySelector("[data-ap-cart-priority-plus]");
        if (priorityPlusRow) {
          priorityPlusRow.classList.toggle("is-selected", priorityPlusToggle.checked);
        }
        renderTotals(state.cart || { items: [] });
        if (!priorityPlusToggle.checked && state.cart) cleanupDeselectedPriorityPlus(state.cart);
        trackCartEvent("priority_plus_toggled", {
          enabled: priorityPlusToggle.checked,
          price: Number(root.dataset.priorityPlusPrice || 0) / 100
        });
        return;
      }
      var variantSelect = event.target.closest("[data-ap-cart-rec-variant]");
      if (!variantSelect) return;
      var rec = variantSelect.closest("[data-ap-cart-rec]");
      var selected = variantSelect.options[variantSelect.selectedIndex];
      var button = rec && rec.querySelector("[data-ap-cart-add-variant]");
      var price = rec && rec.querySelector("[data-ap-cart-rec-price]");
      if (button) button.setAttribute("data-ap-cart-add-variant", variantSelect.value);
      if (price && selected && selected.getAttribute("data-price")) {
        price.textContent = money(selected.getAttribute("data-price"));
      }
      trackCartEvent("recommendation_variant_selected", {
        variant_id: variantSelect.value,
        recommendation_id: rec ? rec.getAttribute("data-ap-cart-rec") || "" : "",
        product_id: rec ? rec.getAttribute("data-ap-cart-rec-product") || "" : "",
        price: selected && selected.getAttribute("data-price") ? Number(selected.getAttribute("data-price")) / 100 : ""
      });
    });

    document.addEventListener("keydown", function (event) {
      if (!root.classList.contains("is-open")) return;
      var dialog = event.target.closest && event.target.closest("[role=dialog][aria-modal=true]");
      if (dialog && !root.contains(dialog)) return;
      if (event.key === "Escape") { event.preventDefault(); closeCart(); return; }
      if (event.key !== "Tab") return;
      var controls = Array.from(root.querySelectorAll("button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex='0']")).filter(function (node) { return node.getClientRects().length && !node.closest("[hidden]"); });
      if (!controls.length) return;
      var first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    });

    document.addEventListener("click", function (event) {
      if (!root.classList.contains("is-enabled")) return;
      var panel = root.querySelector(".ap-cart__panel");
      if (root.classList.contains("is-open") && event.target.closest(".ap-cart__overlay")) {
        event.preventDefault();
        event.stopPropagation();
        closeCart();
        return;
      }
      var cartLink = event.target.closest("#cart-icon-bubble, a[href='/cart'], a[href$='/cart']");
      if (!cartLink) return;
      event.preventDefault();
      event.stopPropagation();
      openCart();
    }, true);

    ["cart:added", "cart:refresh", "cart:updated", "UPEZ__ADDED_ITEM", "UPEZ__CART_REFETCHED_AFTER_ADD", "UPEZ__CART_REFETCHED_AFTER_CHANGE", "UPEZ__REMOVED_ITEM"].forEach(function (name) {
      document.addEventListener(name, function () {
        if (root.classList.contains("is-enabled")) {
          scheduleCartRefresh(140);
        }
      });
    });
  }

  function submitProductAddForm(form) {
    var submitter = document.activeElement && form.contains(document.activeElement)
      ? document.activeElement
      : form.querySelector("[type='submit']");
    var formData = new FormData(form);
    var variantId = formData.get("id") || "";
    var quantity = Number(formData.get("quantity") || 1);
    var followUpInput = form.querySelector("[data-ap-followup-addon]:checked");
    var followUpVariantId = followUpInput ? Number(followUpInput.getAttribute("data-variant-id") || 0) : 0;
    var followUpName = followUpInput ? followUpInput.getAttribute("data-addon-name") || "Optional add-on" : "";
    var followUpFailed = false;
    if (submitter) {
      submitter.disabled = true;
      submitter.classList.add("is-busy");
    }
    api(hiddenCartUrl(localePath("/cart/add.js")), {
      method: "POST",
      body: formData
    }).then(function (result) {
      clearError();
      if (isProductPage()) {
        document.dispatchEvent(new CustomEvent("ap:pdp:purchase_success", {
          detail: { source: "product_form", payload: result }
        }));
      }
      if (!followUpVariantId) return result;
      return api(hiddenCartUrl(localePath("/cart/add.js")), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: followUpVariantId, quantity: 1, properties: { "_addon": followUpName } }] })
      }).then(function (addonResult) {
        document.dispatchEvent(new CustomEvent("ap:pdp:followup_addon_success", {
          detail: { variant_id: followUpVariantId, name: followUpName, source: "product_form" }
        }));
        trackCartEvent("pdp_followup_addon_added", {
          variant_id: followUpVariantId,
          name: followUpName,
          source: "product_form"
        });
        return result;
      }).catch(function () {
        followUpFailed = true;
        trackCartEvent("pdp_followup_addon_failed", {
          variant_id: followUpVariantId,
          name: followUpName,
          source: "product_form"
        });
        return result;
      });
    }).then(function (result) {
      return openOrRefreshAfterAdd().then(function () {
        if (followUpFailed) showError("Your product was added, but the optional add-on wasn't. You can still check out.");
        trackCartEvent("cart_product_form_added", {
          variant_id: variantId,
          quantity: quantity,
          source: "product_form"
        });
      });
    }).catch(function () {
      document.dispatchEvent(new CustomEvent("ap:pdp:purchase_error"));
      showError(text("add_error", "We couldn't add that product. Please try again."));
    }).finally(function () {
      if (submitter) {
        submitter.disabled = false;
        submitter.classList.remove("is-busy");
      }
    });
  }

  function patchCartMutations() {
    if (window.__apCartDrawerPatched) return;
    window.__apCartDrawerPatched = true;
    var cartWrites = Promise.resolve();
    function queueCartWrite(send) {
      var result = cartWrites.then(send, send);
      cartWrites = result.catch(function () {});
      return result;
    }
    function isCartWrite(url, method) {
      if (String(method || "GET").toUpperCase() !== "POST") return false;
      try {
        var parsed = new URL(url, window.location.href);
        return parsed.origin === window.location.origin && /\/cart(?:\.js|\/(?:add|change|update|clear)(?:\.js)?)$/.test(parsed.pathname);
      } catch (e) { return false; }
    }
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var args = Array.prototype.slice.call(arguments);
      if (root.classList.contains("is-enabled") && isAdd && typeof input === "string") {
        args[0] = hiddenCartUrl(input);
      }
      var owner = this;
      var send = function () { return nativeFetch.apply(owner, args); };
      var method = init && init.method || input && input.method;
      var result = isCartWrite(url, method) ? queueCartWrite(send) : send();
      if (root.classList.contains("is-enabled") && isAdd && !(init && init.apCartOwned)) {
        result.then(function (res) {
          if (res && res.ok) setTimeout(openOrRefreshAfterAdd, 180);
        }).catch(function () {});
      }
      return result;
    };

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      var args = Array.prototype.slice.call(arguments);
      if (root.classList.contains("is-enabled") && /\/cart\/add(\.js)?(\?|$)/.test(String(url || ""))) {
        args[1] = hiddenCartUrl(url);
      }
      this.__apCartDrawerUrl = args[1];
      this.__apCartDrawerMethod = method;
      this.__apCartDrawerAsync = args[2] !== false;
      this.__apCartDrawerAborted = false;
      this.__apCartDrawerGeneration = (this.__apCartDrawerGeneration || 0) + 1;
      return nativeOpen.apply(this, args);
    };
    var nativeAbort = XMLHttpRequest.prototype.abort;
    XMLHttpRequest.prototype.abort = function () {
      this.__apCartDrawerAborted = true;
      return nativeAbort.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (root.classList.contains("is-enabled") && /\/cart\/add(\.js)?(\?|$)/.test(this.__apCartDrawerUrl || "")) {
        this.addEventListener("loadend", function () {
          if (this.status >= 200 && this.status < 300) setTimeout(openOrRefreshAfterAdd, 180);
        });
      }
      if (!this.__apCartDrawerAsync || !isCartWrite(this.__apCartDrawerUrl, this.__apCartDrawerMethod) || this.readyState !== 1) return nativeSend.apply(this, arguments);
      var xhr = this, args = arguments, generation = this.__apCartDrawerGeneration;
      queueCartWrite(function () {
        if (xhr.__apCartDrawerAborted || xhr.__apCartDrawerGeneration !== generation) return;
        return new Promise(function (resolve) {
          xhr.addEventListener("loadend", resolve, { once: true });
          try { nativeSend.apply(xhr, args); }
          catch (e) { resolve(); }
        });
      });
    };
  }

  function warmBundleGroups() {
    if (!state.cart || !eligibleItems(state.cart).length) return;
    if (state.bundleGroupsLoaded || state.bundleGroupsLoading) return;
    if (readBundleGroupCache()) return;
    var warm = function () { loadBundleGroups(); };
    if ("requestIdleCallback" in window) window.requestIdleCallback(warm, { timeout: 1800 });
    else window.setTimeout(warm, 900);
  }

  function init() {
    if (!hasFlag()) return;
    root.classList.add("is-enabled");
    document.body.classList.add("ap-cart-native-mode");
    closeNativeCartDrawer();
    window.apCartDrawer = {
      open: openCart,
      close: closeCart,
      refresh: fetchCart,
      disable: function () {
        window.localStorage.removeItem(FLAG);
        closeCart();
        root.classList.remove("is-enabled");
        document.body.classList.remove("ap-cart-native-mode");
      }
    };
    bindEvents();
    patchCartMutations();
    installScrollStyles();
    installScrollGuards();
    var initialCart = fetchCart().then(bridgeLoyaltyWidget);
    if (shouldOpenOnLoad()) {
      initialCart.then(function () {
        openCart({ skipRefresh: true });
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete("ap_cart");
        cleanUrl.searchParams.delete("ap_cart_open");
        window.history.replaceState(window.history.state, "", cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
      });
    }
    warmCartGrouping();
    window.setTimeout(bridgeLoyaltyWidget, 900);
    window.addEventListener("pageshow", function (event) {
      if (!event.persisted) return;
      root.querySelectorAll("[data-ap-cart-checkout-plus], [data-ap-cart-checkout-without]").forEach(function (button) {
        if (button.hasAttribute("data-ap-cart-checkout-plus")) setCheckoutLoading(button, false);
        else {
          button.disabled = false;
          button.classList.remove("is-busy");
        }
      });
      fetchCart().then(bridgeLoyaltyWidget);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
